import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type AgentProgressState = 'running' | 'complete' | 'failed' | 'cancelled';
type AgentProgressStepState = 'done' | 'active' | 'failed' | 'unavailable';
type AgentConversationMessage = {
    id?: number;
    role: 'user' | 'agent' | 'progress';
    text: string;
    time: string;
    date?: string;
    clientId?: string;
    conversationId?: string;
    previewAction?: string;
    repair?: { id: string; type: 'retry_generation_job'; label: string; job_id: string;
        cost_notice: string; running?: boolean; done?: boolean };
    progress?: {
        state: AgentProgressState;
        title: string;
        context: string;
        expanded: boolean;
        targetLinked?: boolean;
        steps: Array<{ label: string; state: AgentProgressStepState }>;
    };
};
type AgentActiveRequest = {
    id: string;
    controller: AbortController;
    progress: AgentConversationMessage;
    stopped: boolean;
    waitTimer?: ReturnType<typeof setInterval>;
    imageAgent?: boolean;
    imageAgentRunId?: string;
};
type AgentConversationSummary = {
    id: string;
    title: string;
    preview: string;
    messageCount: number;
    date: string;
    time: string;
};

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
}

.workbench-shell {
  --workbench-agent-panel-width: 27.5rem;
  background: var(--wb-canvas, #f3f6f8);
}

.workbench-agent-collapsed {
  --workbench-collapsed-inset: 2.75rem;
}

.workbench-shell::after {
  position: fixed;
  z-index: 39;
  top: 0;
  right: 0;
  bottom: 0;
  left: calc(16rem + min(var(--workbench-agent-panel-width), 100vw - 36rem));
  background: radial-gradient(ellipse 18rem 7rem at 0 0, rgba(46, 151, 218, 0.35), transparent 82%) 0 0/18rem 7rem no-repeat, linear-gradient(90deg, rgba(0, 106, 166, 0.22), transparent) 0 0/1.5rem 100% no-repeat, linear-gradient(180deg, rgba(0, 106, 166, 0.12), transparent) 0 0/16rem 2.25rem no-repeat;
  box-shadow: inset 1px 0 rgba(0, 106, 166, 0.55);
  content: "";
  opacity: 0;
  pointer-events: none;
  transition: opacity 300ms ease-out;
}

.workbench-agent-open::after {
  animation: workbench-agent-ambient-on 950ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.workbench-agent-open.workbench-agent-inspecting::after {
  box-shadow: inset 1px 0 rgba(22, 117, 233, 0.68), inset 0 0 0 1px rgba(47, 137, 232, 0.18), inset 0 0 28px rgba(47, 137, 232, 0.07);
  animation: workbench-agent-inspect-on 900ms ease-out both;
}

@keyframes workbench-agent-inspect-on {
  0% {
    opacity: 0.22;
  }
  45% {
    opacity: 0.62;
  }
  100% {
    opacity: 0.42;
  }
}
@keyframes workbench-agent-ambient-on {
  0% {
    opacity: 0;
  }
  38% {
    opacity: 0.62;
  }
  100% {
    opacity: 0.22;
  }
}
.workbench-sidebar-frame {
  border-right: 1px solid rgba(16, 44, 58, 0.12);
  background: linear-gradient(180deg, #102c3a 0%, #153746 52%, #102c3a 100%);
  box-shadow: 12px 0 34px rgba(16, 44, 58, 0.12);
}

.workbench-shell:not(.workbench-agent-open) .workbench-sidebar-frame {
  box-shadow: none;
}

.workbench-main {
  min-width: 0;
  container: workspace/inline-size;
  padding-left: var(--workbench-collapsed-inset, 0px);
  padding-bottom: 5rem;
  background: var(--wb-page-canvas, #f5f9fd);
}

.workbench-agent-panel {
  position: fixed;
  z-index: 40;
  inset: 0 auto 0 16rem;
  width: min(var(--workbench-agent-panel-width), 100vw - 36rem);
  min-width: 0;
  border-right: 1px solid #dfe7ee;
  background: #fff;
  color: #102739;
  box-shadow: 8px 0 24px rgba(15, 42, 60, 0.035);
}

.workbench-agent-resize-handle {
  position: absolute;
  z-index: 2;
  top: 0;
  right: -0.5rem;
  width: 1rem;
  height: 100%;
  cursor: col-resize;
  touch-action: none;
}

.workbench-agent-resize-handle::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0.25rem;
  height: 3.5rem;
  transform: translate(-50%, -50%);
  border-radius: 999px;
  background: #b5cad9;
  content: "";
  box-shadow: 0 0 0 2px #fff;
}

.workbench-agent-resize-handle:hover::after,
.workbench-agent-resize-handle:focus-visible::after {
  background: var(--wb-brand, #006aa6);
  box-shadow: 0 0 0 4px var(--wb-brand-soft, #eaf4fa);
}

.workbench-agent-resize-handle:focus-visible {
  outline: 2px solid var(--wb-brand, #006aa6);
  outline-offset: -2px;
}

.workbench-agent-panel.is-collapsed {
  top: 50%;
  bottom: auto;
  width: 2.75rem;
  height: 13.5rem;
  transform: translateY(-50%);
  border: 1px solid #62b0ff;
  border-left: 0;
  border-radius: 0 0.8rem 0.8rem 0;
  background: linear-gradient(180deg, #fff 0%, #f8fbff 100%);
  box-shadow: 0 0 0 2px rgba(75, 166, 255, 0.12), 0 0 18px rgba(42, 145, 245, 0.28);
}

.workbench-agent-content,
.workbench-agent-rail {
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
}

.workbench-agent-content {
  container-type: inline-size;
  overflow: hidden;
}

.workbench-agent-scroll-region {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex: 1 1 0;
  flex-direction: column;
  overflow: auto;
  overscroll-behavior: contain;
}

.workbench-agent-scroll-region > * {
  flex-shrink: 0;
}

.workbench-agent-scroll-region > .workbench-agent-empty,
.workbench-agent-scroll-region > .workbench-agent-conversation,
.workbench-agent-scroll-region > .workbench-agent-history-panel {
  flex: 1 0 auto;
  overflow: visible;
}

.workbench-agent-scroll-region:focus-visible,
.workbench-agent-attachments:focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: -2px;
}

.workbench-agent-header {
  display: flex;
  min-height: 5.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border-bottom: 1px solid #e4eaf0;
  padding: 1rem 1.05rem 1rem 1.25rem;
}

.workbench-agent-header-copy {
  min-width: 0;
}

.workbench-agent-header h2 {
  margin: 0;
  color: #102536;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.025em;
  white-space: nowrap;
}

.workbench-agent-header p {
  margin: 0.25rem 0 0;
  color: #73869b;
  font-size: 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workbench-agent-header-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.1rem;
}

.workbench-agent-header-actions button,
.workbench-agent-rail-button {
  display: grid;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 0.5rem;
  color: #526d84;
  font-size: 0.8rem;
}

.workbench-agent-header-actions button:hover,
.workbench-agent-rail-button:hover {
  background: #eff6fc;
  color: #0967c2;
}

.workbench-agent-header-actions .workbench-agent-history-trigger {
  display: inline-flex;
  width: auto;
  gap: 0.35rem;
  padding: 0 0.45rem;
  color: #376b9d;
  font-size: 0.72rem;
  font-weight: 750;
}

.workbench-agent-header-actions .workbench-agent-new-chat {
  display: inline-flex;
  width: auto;
  gap: 0.3rem;
  padding: 0 0.45rem;
  color: #0967c2;
  font-size: 0.72rem;
  font-weight: 750;
}

.workbench-agent-header-actions .workbench-agent-new-chat:disabled {
  opacity: 0.5;
  cursor: default;
}

@container (max-width: 400px) {
  .workbench-agent-header-actions .workbench-agent-new-chat span,
  .workbench-agent-header-actions .workbench-agent-history-trigger span {
    display: none;
  }
}
.workbench-agent-history-trigger .fa-chevron-up,
.workbench-agent-history-trigger .fa-chevron-down {
  margin-left: 0.1rem;
  font-size: 0.58rem;
}

.workbench-agent-header-actions .workbench-agent-history-trigger.is-active {
  background: #e7f2ff;
  color: #0967c2;
}

.workbench-agent-header-actions .workbench-agent-history-trigger:disabled {
  opacity: 0.5;
  cursor: default;
}

.workbench-agent-auth {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  border-bottom: 1px solid #e4eaf0;
  background: #f8fbff;
  padding: 0.7rem 1.25rem;
}

.workbench-agent-auth-label {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.6rem;
}

.workbench-agent-auth-icon {
  display: grid;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 0.55rem;
  background: #e7f2ff;
  color: #0967c2;
  font-size: 0.85rem;
}

.workbench-agent-auth-label strong,
.workbench-agent-auth-label small {
  display: block;
  line-height: 1.25;
}

.workbench-agent-auth-label strong {
  color: #19344c;
  font-size: 0.75rem;
  font-weight: 750;
}

.workbench-agent-auth-label small {
  margin-top: 0.15rem;
  color: #758aa0;
  font-size: 0.6875rem;
}

.workbench-agent-login-button {
  display: inline-flex;
  min-height: 2.25rem;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid #0967c2;
  border-radius: 0.5rem;
  background: #0967c2;
  padding: 0.45rem 0.75rem;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 750;
  white-space: nowrap;
}

.workbench-agent-login-button:hover {
  border-color: #0756a6;
  background: #0756a6;
}

.workbench-agent-login-button:focus-visible {
  outline: 3px solid #91c5f2;
  outline-offset: 2px;
}

.workbench-agent-login-notice {
  width: 100%;
  margin: 0;
  color: #526d84;
  font-size: 0.72rem;
  line-height: 1.4;
}

.workbench-agent-model-bar {
  display: grid;
  flex: 0 0 auto;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.45rem 0.75rem;
  border-bottom: 1px solid #e4eaf0;
  background: #fff;
  padding: 0.65rem 1.25rem;
}

.workbench-agent-model-bar label {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: #415a72;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.workbench-agent-model-bar label i {
  color: #0967c2;
}

.workbench-agent-model-bar select {
  width: 100%;
  min-width: 0;
  min-height: 2.25rem;
  border: 1px solid #d4e0ec;
  border-radius: 0.5rem;
  background: #f8fbff;
  padding: 0.4rem 0.6rem;
  color: #19344c;
  font-size: 0.75rem;
  font-weight: 650;
}

.workbench-agent-model-bar select:focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: 2px;
}

.workbench-agent-model-bar select:disabled {
  color: #8ba0b5;
  cursor: not-allowed;
}

.workbench-agent-model-refresh {
  display: inline-grid;
  place-items: center;
  width: 2.25rem;
  height: 2.25rem;
  border: 1px solid #d4e0ec;
  border-radius: 0.5rem;
  background: #f8fbff;
  color: #0967c2;
}

.workbench-agent-model-refresh:hover:not(:disabled) {
  border-color: #7aaee0;
  background: #edf5ff;
}

.workbench-agent-model-refresh:focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: 2px;
}

.workbench-agent-model-refresh:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.workbench-agent-model-notice {
  grid-column: 1/-1;
  margin: 0;
  color: #657f98;
  font-size: 0.6875rem;
  line-height: 1.4;
}

.workbench-agent-runtime-backdrop {
  position: fixed;
  z-index: 100;
  inset: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  place-items: center;
  overflow-y: auto;
  background: rgba(12, 35, 50, 0.5);
  padding: 1rem;
}

.workbench-agent-runtime-modal {
  position: relative;
  width: min(100%, 39rem);
  max-height: 100%;
  overflow-y: auto;
  border: 1px solid var(--wb-border, #dce4e8);
  border-radius: 0.9rem;
  background: var(--wb-surface, #fff);
  color: var(--wb-ink, #102c3a);
  box-shadow: 0 18px 60px rgba(16, 44, 58, 0.2);
}

.workbench-agent-runtime-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: grid;
  width: 2rem;
  height: 2rem;
  place-items: center;
  border: 1px solid transparent;
  border-radius: 0.4rem;
  background: transparent;
  color: var(--wb-muted, #607381);
  font-size: 1.05rem;
}
.workbench-agent-runtime-close:hover {
  border-color: var(--wb-border, #dce4e8);
  background: var(--wb-surface-muted, #f7f9fa);
  color: var(--wb-ink, #102c3a);
}

.workbench-agent-runtime-hero {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1.4rem 3.5rem 1.25rem 1.5rem;
  border-bottom: 1px solid var(--wb-border, #dce4e8);
}
.workbench-agent-runtime-hero p {
  margin: 0.3rem 0 0;
  color: var(--wb-muted, #607381);
  font-size: 0.78rem;
  line-height: 1.5;
}

.workbench-agent-runtime-key {
  display: grid;
  width: 2.6rem;
  height: 2.6rem;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 0.65rem;
  background: var(--wb-brand-soft, #eaf4fa);
  color: var(--wb-brand, #006aa6);
  font-size: 1rem;
}

.workbench-agent-runtime-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem;
}
.workbench-agent-runtime-heading h2 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: -0.025em;
}

.workbench-agent-runtime-badge {
  border-radius: 999px;
  background: var(--wb-brand-soft, #eaf4fa);
  padding: 0.2rem 0.5rem;
  color: var(--wb-brand, #006aa6);
  font-size: 0.68rem;
  font-weight: 700;
}

.workbench-agent-runtime-body {
  padding: 1.25rem 1.5rem 0;
  font-size: 0.82rem;
  line-height: 1.5;
}

.workbench-agent-runtime-info {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  border: 1px solid var(--wb-brand-border, #b3d8eb);
  border-radius: 0.55rem;
  background: var(--wb-brand-soft, #eaf4fa);
  padding: 0.7rem 0.85rem;
  color: #285776;
}
.workbench-agent-runtime-info i {
  margin-top: 0.12rem;
  color: var(--wb-brand, #006aa6);
}
.workbench-agent-runtime-info p {
  margin: 0;
}

.workbench-agent-runtime-auth-box {
  min-height: 7rem;
  margin-top: 0.85rem;
  border: 1px solid var(--wb-border, #dce4e8);
  border-radius: 0.65rem;
  background: var(--wb-surface-muted, #f7f9fa);
  padding: 1rem 1.1rem;
}

.workbench-agent-runtime-instruction {
  margin: 0.55rem 0 0;
  color: var(--wb-muted, #607381);
}

.workbench-agent-runtime-status {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  color: var(--wb-ink, #102c3a);
  font-size: 0.83rem;
}

.workbench-agent-runtime-dot {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  background: #a2b2c0;
}
.workbench-agent-runtime-dot.is-connected {
  background: #12ad74;
  box-shadow: 0 0 0 3px #d9f8eb;
}

.workbench-agent-runtime-device-details {
  margin-top: 0.8rem;
}

.workbench-agent-runtime-link {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  color: var(--wb-brand, #006aa6);
  font-size: 0.88rem;
  font-weight: 700;
  text-decoration: underline;
  overflow-wrap: anywhere;
}

.workbench-agent-runtime-code-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem;
  margin-top: 0.8rem;
}
.workbench-agent-runtime-code-row > span {
  color: #738491;
  font-weight: 700;
}
.workbench-agent-runtime-code-row strong {
  border: 1px solid var(--wb-brand-border, #b3d8eb);
  border-radius: 0.45rem;
  background: #fff;
  padding: 0.45rem 0.75rem;
  color: var(--wb-ink, #102c3a);
  font-size: 1.3rem;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.workbench-agent-runtime-code-row small {
  color: var(--wb-muted, #607381);
  font-size: 0.72rem;
}

.workbench-agent-runtime-copy {
  display: grid;
  width: 2.3rem;
  height: 2.3rem;
  place-items: center;
  border: 1px solid #d1dde2;
  border-radius: 0.45rem;
  background: #fff;
  color: var(--wb-brand, #006aa6);
  font-size: 0.85rem;
}
.workbench-agent-runtime-copy:hover {
  border-color: var(--wb-brand, #006aa6);
}

.workbench-agent-runtime-hint {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  margin: 0.8rem 0 0;
  color: var(--wb-muted, #607381);
  font-size: 0.72rem;
}
.workbench-agent-runtime-hint i {
  padding-top: 0.15rem;
}

.workbench-agent-runtime-error {
  color: #a93434;
}

.workbench-agent-runtime-identity {
  color: #4e6b83;
}

.workbench-agent-runtime-footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 1rem 1.5rem 0;
  border-top: 1px solid var(--wb-border, #dce4e8);
  padding: 0.9rem 0 1.2rem;
}
.workbench-agent-runtime-footer button, .workbench-agent-runtime-footer a {
  display: inline-flex;
  min-height: 2.3rem;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  border: 1px solid var(--wb-border, #dce4e8);
  border-radius: 0.45rem;
  background: #fff;
  padding: 0.45rem 0.75rem;
  color: var(--wb-ink, #102c3a);
  font-size: 0.76rem;
  font-weight: 750;
  text-decoration: none;
}
.workbench-agent-runtime-footer .workbench-agent-runtime-link-button {
  border-color: var(--wb-brand-border, #b3d8eb);
  background: var(--wb-brand-soft, #eaf4fa);
  color: var(--wb-brand, #006aa6);
}
.workbench-agent-runtime-footer .workbench-agent-runtime-primary {
  border-color: var(--wb-brand, #006aa6);
  background: var(--wb-brand, #006aa6);
  color: #fff;
}
.workbench-agent-runtime-footer .workbench-agent-runtime-primary:hover {
  background: var(--wb-brand-hover, #005585);
}
.workbench-agent-runtime-footer .workbench-agent-runtime-danger {
  border-color: #efd1d1;
  color: #ad4545;
}

.workbench-agent-runtime-close:focus-visible,
.workbench-agent-runtime-copy:focus-visible,
.workbench-agent-runtime-link:focus-visible,
.workbench-agent-runtime-footer button:focus-visible,
.workbench-agent-runtime-footer a:focus-visible {
  outline: 2px solid var(--wb-brand, #006aa6);
  outline-offset: 2px;
}

@media (max-width: 640px) {
  .workbench-agent-runtime-hero {
    padding: 1.1rem 2.8rem 1rem 1rem;
  }
  .workbench-agent-runtime-body {
    padding: 1rem 1rem 0;
  }
  .workbench-agent-runtime-auth-box {
    padding: 0.9rem;
  }
  .workbench-agent-runtime-footer {
    justify-content: stretch;
    margin: 0.8rem 1rem 0;
  }
  .workbench-agent-runtime-footer button, .workbench-agent-runtime-footer a {
    flex: 1 1 auto;
  }
  .workbench-agent-runtime-footer .workbench-agent-runtime-primary {
    flex-basis: 100%;
  }
}
.workbench-agent-empty {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 1.5rem 1.25rem;
  text-align: center;
}

.workbench-agent-empty h3 {
  margin: 0;
  color: #142b49;
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: -0.035em;
}

.workbench-agent-empty > p {
  margin: 0.75rem 0 0;
  color: #71859d;
  font-size: 0.8125rem;
  line-height: 1.65;
}

.workbench-agent-suggestions {
  display: grid;
  width: 100%;
  gap: 0.7rem;
  margin-top: 2.25rem;
}

.workbench-agent-suggestions button {
  display: flex;
  min-height: 3rem;
  align-items: center;
  gap: 0.75rem;
  border: 1px solid #e0e8f0;
  border-radius: 0.55rem;
  background: #fff;
  padding: 0.7rem 0.85rem;
  color: #18334f;
  font-size: 0.8125rem;
  font-weight: 650;
  text-align: left;
}

.workbench-agent-suggestions button:hover {
  border-color: #9fc8ed;
  background: #f7fbff;
}

.workbench-agent-suggestions button i:first-child {
  width: 1.1rem;
  flex: 0 0 auto;
  color: #0b68c6;
  text-align: center;
}

.workbench-agent-suggestions button span {
  flex: 1 1 auto;
}

.workbench-agent-suggestions button i:last-child {
  color: #0b68c6;
  font-size: 0.7rem;
}

.workbench-agent-conversation {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1.25rem;
}

.workbench-agent-history-panel {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1rem 1.1rem 1.25rem;
  background: #fbfdff;
}

.workbench-agent-history-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.6rem;
}

.workbench-agent-history-heading h3 {
  margin: 0;
  color: #19344c;
  font-size: 0.9rem;
  font-weight: 800;
}

.workbench-agent-history-heading p {
  margin: 0.25rem 0 0;
  color: #7b8fa4;
  font-size: 0.68rem;
}

.workbench-agent-history-heading button {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  flex: none;
  border: 1px solid #d3e2f0;
  border-radius: 0.45rem;
  background: #fff;
  padding: 0.35rem 0.5rem;
  color: #1767ad;
  font-size: 0.68rem;
  font-weight: 750;
}

.workbench-agent-history-search {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0.95rem 0 1rem;
  border: 1px solid #d4e1ed;
  border-radius: 0.6rem;
  background: #fff;
  padding: 0.65rem 0.75rem;
  color: #6f8fac;
}

.workbench-agent-history-search:focus-within {
  border-color: #418dd4;
  box-shadow: 0 0 0 3px rgba(9, 103, 194, 0.1);
}

.workbench-agent-history-search input {
  min-width: 0;
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: #19344c;
  font-size: 0.76rem;
}

.workbench-agent-history-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  color: #7b8fa4;
  font-size: 0.69rem;
  font-weight: 700;
}

.workbench-agent-history-toolbar button {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #a44643;
  font-size: 0.69rem;
  font-weight: 750;
}

.workbench-agent-history-toolbar button:hover:not(:disabled) {
  color: #8e2f2c;
}

.workbench-agent-history-toolbar button:disabled {
  opacity: 0.5;
  cursor: default;
}

.workbench-agent-history-delete-confirm {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.55rem 0.7rem;
  width: 100%;
  max-width: 29rem;
  margin: 0.65rem 0 0.8rem auto;
  border: 1px solid #dce7f1;
  border-radius: 0.65rem;
  background: #fff;
  padding: 0.65rem 0.75rem;
  box-shadow: 0 4px 14px rgba(25, 52, 76, 0.05);
}

.workbench-agent-history-delete-icon {
  display: grid;
  width: 1.9rem;
  height: 1.9rem;
  flex: none;
  place-items: center;
  border-radius: 0.5rem;
  background: #fbeeed;
  color: #b64f49;
  font-size: 0.76rem;
}

.workbench-agent-history-delete-copy {
  flex: 1 1 10rem;
  min-width: 0;
}

.workbench-agent-history-delete-copy strong {
  color: #263c52;
  font-size: 0.76rem;
  font-weight: 800;
}

.workbench-agent-history-delete-copy p {
  margin: 0.16rem 0 0;
  color: #71869a;
  font-size: 0.67rem;
  line-height: 1.4;
}

.workbench-agent-history-delete-actions {
  display: flex;
  gap: 0.35rem;
  margin-left: auto;
}

.workbench-agent-history-delete-actions button {
  min-height: 1.9rem;
  border: 1px solid #dce5ee;
  border-radius: 0.45rem;
  background: #fff;
  padding: 0.32rem 0.65rem;
  color: #567087;
  font-size: 0.68rem;
  font-weight: 750;
  white-space: nowrap;
}

.workbench-agent-history-delete-actions button:hover:not(:disabled) {
  background: #f5f8fb;
}

.workbench-agent-history-delete-actions button.is-danger {
  border-color: #b64f49;
  background: #b64f49;
  color: #fff;
}

.workbench-agent-history-delete-actions button.is-danger:hover:not(:disabled) {
  background: #a5413b;
}

.workbench-agent-history-delete-actions button:disabled {
  opacity: 0.6;
  cursor: default;
}

.workbench-agent-history-delete-error {
  margin: 0.6rem 0;
  color: #a3312d;
  font-size: 0.72rem;
}

.workbench-agent-history-state {
  margin: 1.5rem 0;
  color: #7890a7;
  font-size: 0.75rem;
  text-align: center;
}

.workbench-agent-history-date {
  margin: 1rem 0 0.55rem;
  color: #7d91a7;
  font-size: 0.68rem;
  font-weight: 750;
  text-align: center;
}

.workbench-agent-history-conversation-row {
  display: flex;
  align-items: stretch;
  margin-top: 0.85rem;
  border: 1px solid #dce7f1;
  border-radius: 0.75rem;
  background: #fff;
  overflow: hidden;
}

.workbench-agent-history-conversation-trigger {
  display: block;
  min-width: 0;
  flex: 1 1 auto;
  padding: 0.8rem 0.85rem;
  color: #19344c;
  text-align: left;
}

.workbench-agent-history-conversation-trigger:hover {
  background: #f6faff;
}

.workbench-agent-history-conversation-row:focus-within {
  border-color: #7bb4e9;
}

.workbench-agent-history-trigger:focus-visible,
.workbench-agent-history-heading button:focus-visible,
.workbench-agent-history-conversation-trigger:focus-visible,
.workbench-agent-history-delete-conversation:focus-visible,
.workbench-agent-history-delete-item:focus-visible,
.workbench-agent-history-toolbar button:focus-visible,
.workbench-agent-history-delete-actions button:focus-visible,
.workbench-agent-history-more:focus-visible {
  outline: 2px solid #418dd4;
  outline-offset: 2px;
}

.workbench-agent-history-conversation-heading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.workbench-agent-history-conversation-icon {
  display: grid;
  width: 2rem;
  height: 2rem;
  flex: none;
  place-items: center;
  border-radius: 0.6rem;
  background: #eaf3ff;
  color: #0b68c6;
}

.workbench-agent-history-conversation-title {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.15rem;
  font-size: 0.78rem;
}

.workbench-agent-history-conversation-title small {
  color: #8297ac;
  font-size: 0.66rem;
}

.workbench-agent-history-conversation-heading > i {
  color: #5e83a8;
  font-size: 0.7rem;
}

.workbench-agent-history-conversation-preview {
  display: -webkit-box;
  overflow: hidden;
  margin: 0.7rem 0 0 2.5rem;
  color: #3c5268;
  font-size: 0.75rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.workbench-agent-history-conversation-action {
  display: block;
  margin-top: 0.55rem;
  color: #1767ad;
  font-size: 0.68rem;
  font-weight: 750;
  text-align: right;
}

.workbench-agent-history-delete-conversation {
  position: relative;
  display: grid;
  width: 2.35rem;
  flex: none;
  place-items: center;
  overflow: hidden;
  border-left: 1px solid #e5edf5;
  color: #9b7370;
  font-size: 0.76rem;
  transition: color 0.22s ease, border-color 0.22s ease;
}

.workbench-agent-history-delete-conversation::before {
  position: absolute;
  inset: 0;
  background: #bd4844;
  content: "";
  transform: translateY(100%);
  transition: transform 0.24s ease;
}

.workbench-agent-history-delete-conversation > i {
  position: relative;
  z-index: 1;
}

.workbench-agent-history-delete-conversation:hover:not(:disabled):not(.is-armed) {
  background: #fff5f4;
  color: #a43833;
}

.workbench-agent-history-delete-conversation.is-armed {
  border-left-color: #bd4844;
  color: #fff;
}

.workbench-agent-history-delete-conversation.is-armed::before {
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .workbench-agent-history-delete-conversation,
  .workbench-agent-history-delete-conversation::before {
    transition: none;
  }
}
.workbench-agent-history-delete-conversation:disabled,
.workbench-agent-history-conversation-trigger:disabled {
  opacity: 0.55;
  cursor: default;
}

.workbench-agent-history-delete-conversation.is-armed:disabled {
  opacity: 1;
  cursor: progress;
}

.workbench-agent-history-transcript {
  border-top: 1px solid #e5edf5;
  background: #f9fbfe;
  padding: 0.35rem 0.75rem 0.75rem;
}

.workbench-agent-history-message {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0.75rem 0;
}

.workbench-agent-history-message.is-user {
  align-items: flex-end;
}

.workbench-agent-history-message .workbench-agent-history-date {
  align-self: stretch;
}

.workbench-agent-history-message-heading {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.3rem;
  color: #44617e;
  font-size: 0.68rem;
}

.workbench-agent-history-message-heading span {
  color: #93a7ba;
}

.workbench-agent-history-delete-item {
  color: #9b7370;
  font-size: 0.7rem;
}

.workbench-agent-history-delete-item:hover:not(:disabled) {
  color: #a43833;
}

.workbench-agent-history-delete-item:disabled {
  opacity: 0.5;
  cursor: default;
}

.workbench-agent-history-message-bubble {
  max-width: 95%;
  margin: 0;
  border-radius: 0.65rem;
  background: #edf2f8;
  padding: 0.6rem 0.7rem;
  color: #2b4259;
  font-size: 0.75rem;
  line-height: 1.55;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.workbench-agent-history-message.is-user .workbench-agent-history-message-bubble {
  background: #e7f0ff;
  color: #153e6b;
}

.workbench-agent-history-more {
  display: block;
  margin: 0 auto 1rem;
  padding: 0.45rem 0.8rem;
  border: 1px solid #d5e4f4;
  border-radius: 0.65rem;
  background: #f5f9fe;
  color: #125da8;
  font-size: 0.75rem;
  font-weight: 700;
}

.workbench-agent-history-more:disabled {
  opacity: 0.6;
}

.workbench-agent-history-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.6rem 0.75rem;
  border: 1px solid #f6caca;
  border-radius: 0.65rem;
  background: #fff7f7;
  color: #a72e2e;
  font-size: 0.75rem;
}

.workbench-agent-history-error button {
  flex: none;
  color: #9d2424;
  font-weight: 750;
  text-decoration: underline;
}

.workbench-agent-date {
  align-self: stretch;
  margin: 0.15rem 0 1.25rem;
  color: #7d91a7;
  font-size: 0.6875rem;
  text-align: center;
}

.workbench-agent-message {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 1.2rem;
}

.workbench-agent-image-runs {
  display: grid;
  gap: 0.8rem;
  min-width: 0;
  padding: 0.9rem 0.85rem 1.2rem;
  color: #18394d;
}

.workbench-agent-image-runs-heading,
.workbench-agent-image-run > header,
.workbench-agent-image-evaluation li > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  min-width: 0;
}

.workbench-agent-image-runs-heading h3 {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 750;
}

.workbench-agent-image-runs button {
  border: 1px solid #c7d8e4;
  border-radius: 0.35rem;
  padding: 0.35rem 0.5rem;
  background: #fff;
  color: #27516d;
  font-size: 0.72rem;
  line-height: 1.4;
  white-space: normal;
}

.workbench-agent-image-runs button:focus-visible,
.workbench-agent-image-runs summary:focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: 2px;
}

.workbench-agent-image-runs button:disabled {
  opacity: 0.55;
  cursor: wait;
}

.workbench-agent-image-runs-heading button {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.workbench-agent-image-run {
  min-width: 0;
  border: 1px solid #c7d8e4;
  border-left: 3px solid #527a94;
  border-radius: 0.4rem;
  padding: 0.8rem;
  background: #fff;
  overflow-wrap: anywhere;
}

.workbench-agent-image-run.is-active {
  border-left-color: #0967c2;
}

.workbench-agent-image-run.needs-review {
  border-left-color: #ad5938;
}

.workbench-agent-image-run > header > div {
  display: grid;
  gap: 0.2rem;
  min-width: 0;
}

.workbench-agent-image-run > header strong {
  font-size: 0.8rem;
  line-height: 1.5;
}

.workbench-agent-image-run > header small,
.workbench-agent-image-condition {
  color: #587184;
  font-size: 0.72rem;
  line-height: 1.6;
}

.workbench-agent-image-stage {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0.75rem 0 0.4rem;
  font-size: 0.8rem;
}

.workbench-agent-image-message {
  margin: 0.4rem 0;
  font-size: 0.78rem;
  line-height: 1.65;
  white-space: pre-wrap;
}

.workbench-agent-image-condition {
  margin: 0.25rem 0;
}

.workbench-agent-image-results {
  display: grid;
  gap: 0.75rem;
  margin: 0.8rem 0 0.5rem;
}

.workbench-agent-image-results figure {
  margin: 0;
  min-width: 0;
}

.workbench-agent-image-results img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 26rem;
  object-fit: contain;
  background: #f0f4f7;
}

.workbench-agent-image-results figcaption,
.workbench-agent-image-results figure > p {
  margin: 0.3rem 0;
  color: #587184;
  font-size: 0.72rem;
  line-height: 1.5;
}

.workbench-agent-image-run details {
  margin-top: 0.7rem;
  padding-top: 0.6rem;
  border-top: 1px solid #e0e8ef;
  font-size: 0.75rem;
  line-height: 1.6;
}

.workbench-agent-image-run summary {
  color: #27516d;
  cursor: pointer;
  font-weight: 700;
}

.workbench-agent-image-evaluation ul {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0;
}

.workbench-agent-image-evaluation li {
  margin-top: 0.55rem;
}

.workbench-agent-image-evaluation li > div {
  align-items: flex-start;
}

.workbench-agent-image-evaluation li > div > span {
  flex-shrink: 0;
  color: #287368;
}

.workbench-agent-image-evaluation li.is-failed > div > span {
  color: #ad4932;
}

.workbench-agent-image-evaluation li.is-unknown > div > span {
  color: #8a6724;
}

.workbench-agent-image-evaluation li p {
  margin: 0.2rem 0 0;
  white-space: pre-wrap;
  color: #526b7e;
}

.workbench-agent-trigger-points {
  margin: 0.7rem 0;
  padding: 0.65rem;
  border: 1px solid #d8e4ed;
  border-radius: 0.35rem;
  background: #f8fbfd;
  font-size: 0.75rem;
  line-height: 1.6;
}

.workbench-agent-trigger-points h4 {
  margin: 0;
  color: #294b65;
  font-size: 0.78rem;
  font-weight: 750;
}

.workbench-agent-trigger-points details {
  margin-top: 0.35rem;
  padding-top: 0.25rem;
}

.workbench-agent-image-events ol {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
}

.workbench-agent-image-plan p {
  margin: 0.5rem 0 0;
  white-space: pre-wrap;
}

.workbench-agent-image-open {
  display: inline-block;
  margin: 0.5rem 0;
  color: #0967c2;
  font-size: 0.75rem;
  text-decoration: underline;
  text-underline-offset: 0.15rem;
}

.workbench-agent-analysis-cuts {
  margin: 0.5rem 0;
  padding-left: 1.1rem;
  font-size: 0.75rem;
  line-height: 1.65;
}

.workbench-agent-analysis-cuts a {
  color: #27516d;
  text-decoration: underline;
  text-underline-offset: 0.15rem;
}

.workbench-agent-image-runs a:focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: 2px;
}

.workbench-agent-message.is-user {
  align-items: flex-end;
}

.workbench-agent-speaker {
  margin-bottom: 0.4rem;
  color: #29435c;
  font-size: 0.75rem;
  font-weight: 750;
}

.workbench-agent-bubble {
  max-width: 100%;
  margin: 0;
  border-radius: 0.75rem 0.75rem 0.75rem 0.2rem;
  background: #f0f4f8;
  padding: 0.75rem 0.9rem;
  color: #1f3349;
  font-size: 0.8125rem;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.workbench-agent-message.is-user .workbench-agent-bubble {
  border-radius: 0.75rem 0.75rem 0.2rem 0.75rem;
  background: #e7f0fe;
  color: #193b68;
}

.workbench-agent-time {
  margin-top: 0.35rem;
  color: #8ca0b3;
  font-size: 0.65rem;
}

.workbench-agent-preview-note {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  margin-top: 0.8rem;
  border-radius: 0.55rem;
  background: #f1f6fd;
  padding: 0.75rem 0.85rem;
  color: #3064a6;
  font-size: 0.75rem;
  font-weight: 700;
}

.workbench-agent-download {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin-top: 0.65rem;
  padding: 0.7rem 0.85rem;
  border: 1px solid #bbd2f7;
  border-radius: 0.55rem;
  background: #edf5ff;
  color: #0b59cc;
  font-size: 0.78rem;
  font-weight: 700;
  text-decoration: none;
}

.workbench-agent-download:hover {
  border-color: #6fa5ef;
  background: #e2efff;
}

.workbench-agent-message.is-progress {
  width: 100%;
  margin-top: 0.1rem;
}

.workbench-agent-progress {
  position: relative;
  width: 100%;
  color: #19344c;
}

.workbench-agent-progress.has-target::after {
  position: absolute;
  top: 0.9rem;
  right: -0.95rem;
  bottom: -0.25rem;
  width: 1.25rem;
  border-right: 1px solid rgba(9, 103, 194, 0.5);
  border-bottom: 1px solid rgba(9, 103, 194, 0.5);
  content: "";
  pointer-events: none;
}

.workbench-agent-progress.has-target::before {
  position: absolute;
  z-index: 1;
  right: -1.1rem;
  bottom: -0.45rem;
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: #2286df;
  content: "";
  pointer-events: none;
}

.workbench-agent-progress-summary {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  min-height: 2.35rem;
}

.workbench-agent-progress-icon {
  display: grid;
  width: 1.4rem;
  height: 1.4rem;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  background: #eaf4ff;
  color: #0967c2;
  font-size: 0.9rem;
}

.workbench-agent-progress.is-failed .workbench-agent-progress-icon {
  background: #fff0ed;
  color: #b24a37;
}

.workbench-agent-progress-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.1rem;
  padding-top: 0.1rem;
}

.workbench-agent-progress-copy strong {
  color: #18344f;
  font-size: 0.875rem;
  font-weight: 750;
  line-height: 1.4;
}

.workbench-agent-progress-copy small {
  color: #7c91a4;
  font-size: 0.75rem;
  line-height: 1.45;
}

.workbench-agent-progress-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: calc(100% - 4rem);
  min-height: 2rem;
  margin: 0.4rem 0 0 1.65rem;
  border: 1px solid #e7edf3;
  border-radius: 0.55rem 0.55rem 0 0;
  background: #f7f9fc;
  padding: 0.45rem 0.7rem;
  color: #56718b;
  font-size: 0.75rem;
  font-weight: 650;
  text-align: left;
}

.workbench-agent-progress-toggle[aria-expanded=false] {
  border-radius: 0.55rem;
}

.workbench-agent-progress-toggle:hover {
  background: #edf5fc;
  color: #0967c2;
}

.workbench-agent-progress-toggle:focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: 2px;
}

.workbench-agent-progress-toggle i {
  font-size: 0.55rem;
}

.workbench-agent-progress-steps {
  display: grid;
  gap: 0.45rem;
  width: calc(100% - 4rem);
  margin: 0 0 0 1.65rem;
  border: 1px solid #e7edf3;
  border-top: 0;
  border-radius: 0 0 0.55rem 0.55rem;
  background: #f7f9fc;
  padding: 0.55rem 0.7rem 0.65rem;
  list-style: none;
}

.workbench-agent-progress-steps li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  color: #496178;
  font-size: 0.75rem;
  line-height: 1.45;
}

.workbench-agent-progress-steps li i {
  width: 0.9rem;
  flex: 0 0 auto;
  padding-top: 0.1rem;
  color: #0967c2;
  text-align: center;
}

.workbench-agent-progress-steps li.is-active {
  color: #0967c2;
  font-weight: 700;
}

.workbench-agent-progress-steps li.is-failed,
.workbench-agent-progress-steps li.is-failed i {
  color: #b24a37;
}

.workbench-agent-progress-steps li.is-unavailable,
.workbench-agent-progress-steps li.is-unavailable i {
  color: #8799a8;
}

.workbench-agent-composer {
  display: flex;
  min-width: 0;
  min-height: 0;
  max-height: calc(100% - 7rem);
  flex: 0 0 auto;
  flex-direction: column;
  padding: 0.75rem 0.9rem max(1rem, env(safe-area-inset-bottom));
}

.workbench-agent-attachments {
  display: flex;
  min-width: 0;
  min-height: 0;
  max-height: min(6.5rem, var(--workbench-visible-height, 100dvh) * 0.22);
  flex: 0 1 auto;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.55rem;
  overflow: auto;
  overscroll-behavior: contain;
}

.workbench-agent-attachment-chip {
  display: inline-flex;
  min-width: 0;
  max-width: 100%;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.45rem;
  border: 1px solid #d2e2f4;
  border-radius: 0.45rem;
  background: #f1f7ff;
  color: #255a92;
  font-size: 0.7rem;
}

.workbench-agent-attachment-chip span {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workbench-agent-attachment-chip button {
  display: grid;
  flex: none;
  width: 1.5rem;
  height: 1.5rem;
  place-items: center;
  border-radius: 0.2rem;
  color: #55718d;
}

.workbench-agent-attachment-chip button:hover {
  background: #dcecff;
}

.workbench-agent-attachment-error {
  min-height: 0;
  max-height: 3rem;
  margin: 0 0 0.5rem;
  overflow: auto;
  overflow-wrap: anywhere;
  color: #b44437;
  font-size: 0.7rem;
}

.workbench-agent-input-wrap {
  display: flex;
  min-width: 0;
  min-height: 3rem;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid #d4e0ec;
  border-radius: 0.6rem;
  background: #fff;
  padding: 0.35rem 0.4rem 0.35rem 0.85rem;
}

.workbench-agent-input-wrap:focus-within {
  border-color: #418dd4;
  box-shadow: 0 0 0 3px rgba(9, 103, 194, 0.1);
}

.workbench-agent-input-wrap input {
  width: 100%;
  min-width: 0;
  border: 0 !important;
  outline: 0 !important;
  background: transparent;
  color: #19344c;
  font-size: 0.8125rem;
  box-shadow: none !important;
}

.workbench-agent-input-wrap input::placeholder {
  color: #9aacc0;
}

.workbench-agent-input-wrap button {
  display: grid;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  background: #0967c2;
  color: #fff;
}

.workbench-agent-input-wrap button:disabled {
  background: #bfd5ef;
  cursor: default;
}

.workbench-agent-input-wrap .workbench-agent-stop-button {
  background: #245e91;
  border-radius: 0.5rem;
}

.workbench-agent-input-wrap .workbench-agent-stop-button:hover {
  background: #174a75;
}

.workbench-agent-progress.is-cancelled .workbench-agent-progress-icon,
.workbench-agent-progress.is-cancelled .workbench-agent-progress-summary strong {
  color: #647d94;
}

.workbench-agent-input-wrap .workbench-agent-attach-button {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.45rem;
  background: transparent;
  color: #587b9c;
}

.workbench-agent-input-wrap .workbench-agent-attach-button:hover:not(:disabled) {
  background: #edf5fd;
  color: #0967c2;
}

.workbench-agent-input-wrap .workbench-agent-attach-button:disabled {
  background: transparent;
  opacity: 0.5;
  cursor: default;
}

.workbench-agent-bubble {
  white-space: pre-wrap;
}

.workbench-agent-repair-button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin-top: 0.55rem;
  border: 1px solid #b7d3f2;
  border-radius: 0.6rem;
  padding: 0.5rem 0.72rem;
  color: #075caa;
  background: #eef6ff;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
}

.workbench-agent-repair-button:hover:not(:disabled) {
  background: #e2f0ff;
}

.workbench-agent-repair-button:focus-visible {
  outline: 2px solid #086bd0;
  outline-offset: 2px;
}

.workbench-agent-repair-button:disabled {
  opacity: 0.6;
  cursor: default;
}

@media (prefers-reduced-motion: reduce) {
  .workbench-agent-progress .fa-spin {
    animation: none;
  }
}
.workbench-agent-rail {
  align-items: center;
  padding: 0.45rem 0 0.6rem;
}

.workbench-agent-rail-expand {
  display: flex;
  width: 2.25rem;
  height: auto;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  gap: 0.75rem;
  color: #0967c2;
}

.workbench-agent-rail-icon {
  display: grid;
  width: 1.875rem;
  height: 1.875rem;
  place-items: center;
  border-radius: 0.5rem;
  background: #e7f2ff;
  font-size: 0.875rem;
}

.workbench-agent-rail-arrow {
  font-size: 0.75rem;
}

.workbench-agent-rail-expand:hover {
  background: #edf7ff;
}

.workbench-agent-rail-button:last-child {
  margin-top: auto;
}

.workbench-agent-reopen {
  position: fixed;
  z-index: 35;
  bottom: 1.25rem;
  left: 17.25rem;
  display: grid;
  width: 3rem;
  height: 3rem;
  place-items: center;
  border: 1px solid #0967c2;
  border-radius: 50%;
  background: #0967c2;
  color: #fff;
  font-size: 1.1rem;
  box-shadow: 0 8px 24px rgba(9, 103, 194, 0.25);
}

.workbench-agent-reopen:hover {
  background: #0756a6;
}

.workbench-agent-reopen:focus-visible {
  outline: 3px solid #91c5f2;
  outline-offset: 3px;
}

.workbench-mobile-menu {
  bottom: max(1.25rem, env(safe-area-inset-bottom));
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: #006aa6;
  box-shadow: 0 14px 34px rgba(0, 76, 119, 0.3);
}

.workbench-mobile-menu:hover {
  background: #005585;
}

@media (min-width: 1024px) {
  .workbench-main {
    margin-left: 16rem;
    padding-bottom: 0;
  }
  .workbench-agent-open .workbench-main {
    margin-left: calc(16rem + min(var(--workbench-agent-panel-width), 100vw - 36rem));
  }
}
@media (min-width: 1280px) {
  .workbench-agent-panel {
    width: min(var(--workbench-agent-panel-width), 100vw - 56rem);
  }
  .workbench-shell::after {
    left: calc(16rem + min(var(--workbench-agent-panel-width), 100vw - 56rem));
  }
  .workbench-agent-open .workbench-main {
    margin-left: calc(16rem + min(var(--workbench-agent-panel-width), 100vw - 56rem));
  }
}
@media (max-width: 1023px) {
  .workbench-shell {
    --workbench-agent-dock-height: min(max(48dvh, 20rem), 28rem, var(--workbench-visible-height, 100dvh));
  }
  .workbench-shell.workbench-keyboard-visible {
    --workbench-agent-dock-height: min(28rem, var(--workbench-visible-height, 100dvh));
  }
  .workbench-shell::after {
    display: none;
  }
  .workbench-agent-resize-handle {
    display: none;
  }
  .workbench-agent-progress.has-target::before,
  .workbench-agent-progress.has-target::after {
    display: none;
  }
  .workbench-agent-panel {
    left: 0;
    top: auto;
    bottom: 0;
    width: 100%;
    height: var(--workbench-agent-dock-height);
    border-top: 1px solid #dfe7ee;
    box-shadow: 8px 0 32px rgba(15, 42, 60, 0.2);
  }
  .workbench-agent-panel:not(.is-collapsed) {
    container: workbench-agent-sheet/size;
    top: calc(var(--workbench-visible-top, 0px) + var(--workbench-visible-height, 100dvh) - var(--workbench-agent-dock-height));
    bottom: auto;
  }
  .workbench-agent-input-wrap {
    min-height: 3.375rem;
  }
  .workbench-agent-input-wrap input {
    font-size: 1rem;
  }
  .workbench-agent-open .workbench-main {
    height: calc(100% - var(--workbench-agent-dock-height));
    padding-bottom: 5rem;
  }
  .workbench-agent-open .workbench-mobile-menu {
    bottom: calc(100% - var(--workbench-visible-top, 0px) - var(--workbench-visible-height, 100dvh) + var(--workbench-agent-dock-height) + 1rem);
  }
  .workbench-agent-panel.is-collapsed {
    width: 2.75rem;
  }
  .workbench-agent-reopen {
    right: 1rem;
    bottom: max(1rem, env(safe-area-inset-bottom));
    left: auto;
  }
}
@container workbench-agent-sheet (max-height: 22rem) {
  .workbench-agent-content > .workbench-agent-return {
    display: none;
  }
  .workbench-agent-composer {
    max-height: calc(100% - 4rem);
    padding-block: 0.35rem max(0.35rem, env(safe-area-inset-bottom));
  }
  .workbench-agent-input-wrap {
    min-height: 3rem;
    padding-block: 0.15rem;
  }
  .workbench-agent-attachments {
    min-height: 2.25rem;
  }
  .workbench-agent-attachment-error {
    max-height: 1rem;
    margin-bottom: 0.25rem;
  }
}
.workbench-agent-return {
  display: none;
}

@media (max-width: 1023px) {
  .workbench-agent-return {
    display: inline-flex;
    min-height: 44px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-bottom: 1px solid #dfe7ee;
    background: #f5f9fd;
    color: #0967c2;
    font-size: 13px;
    font-weight: 700;
  }
  .workbench-agent-header {
    min-height: 3.5rem;
    padding-block: 0.5rem;
  }
  .workbench-agent-scope {
    padding-block: 5px;
  }
}
.workbench-agent-return:focus-visible {
  outline: 2px solid #0967c2;
  outline-offset: -3px;
}

@media (prefers-reduced-motion: reduce) {
  .workbench-shell::after {
    transition: none;
  }
  .workbench-agent-open::after {
    animation: none;
    opacity: 0.22;
  }
}
.workbench-agent-scope {
  margin: 0;
  padding: 9px 18px;
  border-bottom: 1px solid #e4ecf5;
  background: #f5f9ff;
  color: #4c6a8e;
  font-size: 12px;
  line-height: 1.6;
}

@media (min-width: 1024px) {
  :host ::ng-deep .workbench-agent-open .workbench-main .patient-form-overlay,
  :host ::ng-deep .workbench-agent-open .workbench-main .scenario-drawer-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .comparison-overlay,
  :host ::ng-deep .workbench-agent-open .workbench-main .wb-comparison-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .wb-comparison.is-expanded,
  :host ::ng-deep .workbench-agent-open .workbench-main .schedule-dialog-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .scenario-import-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .reference-modal,
  :host ::ng-deep .workbench-agent-open .workbench-main .prompt-criteria-modal-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .prompt-expanded-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .fixed:has(> [role=dialog]),
  :host ::ng-deep .workbench-agent-open ~ wiz-portal-season-modal .fixed.inset-0 {
    left: calc(16rem + min(var(--workbench-agent-panel-width, 27.5rem), 100vw - 36rem));
    width: auto;
  }
  :host ::ng-deep .workbench-agent-open .scenario-question-drawer {
    max-width: calc(100vw - 16rem - min(var(--workbench-agent-panel-width, 27.5rem), 100vw - 36rem));
  }
}
@media (min-width: 1280px) {
  :host ::ng-deep .workbench-agent-open .workbench-main .patient-form-overlay,
  :host ::ng-deep .workbench-agent-open .workbench-main .scenario-drawer-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .comparison-overlay,
  :host ::ng-deep .workbench-agent-open .workbench-main .wb-comparison-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .wb-comparison.is-expanded,
  :host ::ng-deep .workbench-agent-open .workbench-main .schedule-dialog-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .scenario-import-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .reference-modal,
  :host ::ng-deep .workbench-agent-open .workbench-main .prompt-criteria-modal-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .prompt-expanded-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .fixed:has(> [role=dialog]),
  :host ::ng-deep .workbench-agent-open ~ wiz-portal-season-modal .fixed.inset-0 {
    left: calc(16rem + min(var(--workbench-agent-panel-width, 27.5rem), 100vw - 56rem));
    width: auto;
  }
  :host ::ng-deep .workbench-agent-open .scenario-question-drawer {
    max-width: calc(100vw - 16rem - min(var(--workbench-agent-panel-width, 27.5rem), 100vw - 56rem));
  }
}
:host ::ng-deep .workbench-main > router-outlet + * {
  min-width: 0;
  max-width: 100%;
}

@media (max-width: 1023px) {
  :host ::ng-deep .workbench-agent-open .workbench-main .schedule-dialog-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .scenario-import-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .scenario-drawer-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .scenario-question-drawer,
  :host ::ng-deep .workbench-agent-open .workbench-main .patient-form-overlay,
  :host ::ng-deep .workbench-agent-open .workbench-main .reference-modal,
  :host ::ng-deep .workbench-agent-open .workbench-main .prompt-criteria-modal-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .prompt-expanded-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .comparison-overlay,
  :host ::ng-deep .workbench-agent-open .workbench-main .wb-comparison-backdrop,
  :host ::ng-deep .workbench-agent-open .workbench-main .wb-comparison.is-expanded,
  :host ::ng-deep .workbench-agent-open .workbench-main .fixed:has(> [role=dialog]),
  :host ::ng-deep .workbench-agent-open ~ wiz-portal-season-modal .fixed.inset-0 {
    bottom: min(48dvh, 28rem);
    height: auto;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit, OnDestroy {
    private readonly workspaceAgent = new WorkspaceScreenAgent();
    private readonly openWorkspaceAgent = () => {
        this.setAgentPanelMode('open');
        window.setTimeout(() => document.querySelector<HTMLElement>('input[name="agent-draft"]')?.focus(), 0);
    };
    private readonly prefillWorkbenchRequest = (event: Event) => {
        const text = (event as CustomEvent).detail?.text;
        if (typeof text !== 'string' || !text.trim()) return;
        this.agentDraft = text.slice(0, 2000);
        this.setAgentPanelMode('open');
        window.setTimeout(() => document.querySelector<HTMLElement>('.workbench-agent-composer input[name="agent-draft"]')?.focus(), 0);
    };
    private mobileNavigationReturnFocus: HTMLElement | null = null;
    private agentPanelReturnFocus: HTMLElement | null = null;
    public agentPanelMode: 'open' | 'collapsed' | 'closed' = 'collapsed';
    public agentPanelWidth: number = 440;
    private readonly agentPanelWidthStorageKey = 'ptsd.workbench.agentPanelWidth';
    private agentResizePointerId: number | null = null;
    private agentResizeStartX: number = 0;
    private agentResizeStartWidth: number = 440;
    private agentResizePreviousUserSelect: string = '';
    private agentResizePreviousCursor: string = '';
    public agentDraft: string = '';
    public agentAttachments: File[] = [];
    public agentAttachmentError: string = '';
    public agentRuntimeModalVisible: boolean = false;
    public agentRuntime: { connected: boolean; reconnect_required?: boolean; name?: string; email?: string; models?: Array<{ slug: string; display_name: string }> } = { connected: false };
    public agentModels: Array<{ slug: string; display_name: string }> = [];
    public agentModelsLoading: boolean = false;
    public agentSelectedModel: string = '';
    public agentModelNotice: string = '';
    public agentDevice: { state: string; verification_url?: string; user_code?: string; expires_at?: number } = { state: 'idle' };
    public agentRuntimeError: string = '';
    public agentDeviceCodeCopied: boolean = false;
    public agentSending: boolean = false;
    public agentRepairing: boolean = false;
    public agentScreenInspecting: boolean = false;
    private agentActiveRequest: AgentActiveRequest | null = null;
    private agentStatusTimer: ReturnType<typeof setInterval> | null = null;
    private agentGeneralStatusTimer: ReturnType<typeof setInterval> | null = null;
    private agentRuntimeReturnFocus: HTMLElement | null = null;
    private agentPromptTarget: HTMLElement | null = null;
    public agentMessages: AgentConversationMessage[] = [];
    public agentConversationId: string = '';
    public agentConversationTitle: string = '새 채팅';
    public agentConversationChanging: boolean = false;
    public agentConversationError: string = '';
    public agentHistoryLoading: boolean = false;
    public agentHistoryHasMore: boolean = false;
    public agentHistoryBefore: number | null = null;
    public agentHistoryError: string = '';
    private agentHistoryLoadSequence: number = 0;
    public agentHistoryPanelOpen: boolean = false;
    public agentHistorySearch: string = '';
    public agentHistoryConversations: AgentConversationSummary[] = [];
    public agentHistoryListLoading: boolean = false;
    public agentHistoryListHasMore: boolean = false;
    public agentHistoryListOffset: number | null = null;
    public agentHistoryListError: string = '';
    public agentHistoryDeleteTarget: { mode: 'conversation' | 'all'; conversation?: AgentConversationSummary } | null = null;
    public agentHistoryDeleting: boolean = false;
    public agentHistoryDeleteError: string = '';
    private agentHistorySearchTimer: ReturnType<typeof setTimeout> | null = null;
    private agentHistorySearchSequence: number = 0;
    private agentSaveQueue: Promise<void> = Promise.resolve();
    private agentUnsavedMessages: AgentConversationMessage[] = [];
    public agentImageRuns: any[] = [];
    public agentImageRunError: string = '';
    public agentImageRunsLoading: boolean = false;
    private agentImagePollTimer: ReturnType<typeof setTimeout> | null = null;
    private agentImageRunSequence: number = 0;
    private agentImageDestroyed: boolean = false;
    private agentImageCancelling = new Set<string>();
    private agentImageUnavailable = new Set<string>();
    private readonly syncAgentViewport = () => {
        const viewport = window.visualViewport;
        const height = viewport?.height ?? window.innerHeight;
        const shell = document.querySelector<HTMLElement>('.workbench-shell');
        shell?.style.setProperty('--workbench-visible-height', `${height}px`);
        shell?.style.setProperty('--workbench-visible-top', `${viewport?.offsetTop ?? 0}px`);
        shell?.classList.toggle('workbench-keyboard-visible',
            window.innerWidth < 1024 && window.innerHeight - height > 120);
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        window.addEventListener('ptsd:agent:open', this.openWorkspaceAgent);
        window.addEventListener('ptsd:agent:prefill', this.prefillWorkbenchRequest);
        window.addEventListener('resize', this.syncAgentViewport);
        window.visualViewport?.addEventListener('resize', this.syncAgentViewport);
        window.visualViewport?.addEventListener('scroll', this.syncAgentViewport);
        this.syncAgentViewport();
        try {
            const savedWidth = Number(window.localStorage.getItem(this.agentPanelWidthStorageKey));
            if (Number.isFinite(savedWidth) && savedWidth >= 320) this.agentPanelWidth = Math.min(savedWidth, 640);
        } catch (_error) { /* Storage may be unavailable in private browsing. */ }
        await this.service.init();
        await this.loadCurrentAgentConversation();
        try {
            this.agentSelectedModel = window.localStorage.getItem(this.agentModelStorageKey()) || '';
        } catch (_error) { /* Model selection still works when storage is unavailable. */ }
        if (this.service.status.navbar === undefined) {
            await this.service.status.toggle('navbar', true);
        }
        // Keep the workbench visible until the agent panel is opened.
        if (window.innerWidth < 1024) this.agentPanelMode = 'closed';
        await this.refreshAgentStatus();
        this.agentGeneralStatusTimer = setInterval(() => void this.refreshAgentStatus(), 30000);
    }

    public ngOnDestroy() {
        this.agentImageDestroyed = true;
        this.agentImageRunSequence++;
        if (this.agentImagePollTimer) clearTimeout(this.agentImagePollTimer);
        window.removeEventListener('ptsd:agent:open', this.openWorkspaceAgent);
        window.removeEventListener('ptsd:agent:prefill', this.prefillWorkbenchRequest);
        window.removeEventListener('resize', this.syncAgentViewport);
        window.visualViewport?.removeEventListener('resize', this.syncAgentViewport);
        window.visualViewport?.removeEventListener('scroll', this.syncAgentViewport);
        if (this.agentHistorySearchTimer) clearTimeout(this.agentHistorySearchTimer);
        this.clearAgentPromptTarget();
        this.endAgentPanelResize(undefined, false);
        if (this.agentStatusTimer) clearInterval(this.agentStatusTimer);
        if (this.agentGeneralStatusTimer) clearInterval(this.agentGeneralStatusTimer);
    }

    public get isAgentAdmin() {
        return this.service.auth.session?.role === 'admin';
    }

    private agentModelStorageKey() {
        return `ptsd.workbench.agentModel.${this.service.auth.session?.id || 'current'}`;
    }

    public get agentPanelMaxWidth() {
        const remainingSpace = window.innerWidth >= 1280 ? 896 : 576;
        return Math.min(640, Math.max(320, window.innerWidth - remainingSpace));
    }

    public get agentPanelEffectiveWidth() {
        return Math.min(this.agentPanelWidth, this.agentPanelMaxWidth);
    }

    private setAgentPanelWidth(width: number, save: boolean = false) {
        this.agentPanelWidth = Math.max(320, Math.min(Math.round(width), this.agentPanelMaxWidth));
        document.querySelector<HTMLElement>('.workbench-shell')?.style.setProperty('--workbench-agent-panel-width', `${this.agentPanelWidth}px`);
        if (save) {
            try { window.localStorage.setItem(this.agentPanelWidthStorageKey, String(this.agentPanelWidth)); }
            catch (_error) { /* Resizing still works when storage is unavailable. */ }
        }
    }

    public startAgentPanelResize(event: PointerEvent) {
        if (this.agentPanelMode !== 'open' || window.innerWidth < 1024 || event.button !== 0) return;
        event.preventDefault();
        this.agentResizePointerId = event.pointerId;
        this.agentResizeStartX = event.clientX;
        this.agentResizeStartWidth = this.agentPanelEffectiveWidth;
        this.agentResizePreviousUserSelect = document.body.style.userSelect;
        this.agentResizePreviousCursor = document.body.style.cursor;
        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'col-resize';
        (event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
    }

    public moveAgentPanelResize(event: PointerEvent) {
        if (event.pointerId !== this.agentResizePointerId) return;
        this.setAgentPanelWidth(this.agentResizeStartWidth + event.clientX - this.agentResizeStartX);
    }

    public endAgentPanelResize(event?: PointerEvent, render: boolean = true) {
        if (this.agentResizePointerId === null || (event && event.pointerId !== this.agentResizePointerId)) return;
        const pointerId = this.agentResizePointerId;
        this.agentResizePointerId = null;
        document.body.style.userSelect = this.agentResizePreviousUserSelect;
        document.body.style.cursor = this.agentResizePreviousCursor;
        const handle = event?.currentTarget as HTMLElement | undefined;
        if (handle?.hasPointerCapture(pointerId)) handle.releasePointerCapture(pointerId);
        this.setAgentPanelWidth(this.agentPanelWidth, true);
        if (render) void this.service.render();
    }

    public onAgentPanelResizeKeydown(event: KeyboardEvent) {
        let nextWidth = this.agentPanelEffectiveWidth;
        if (event.key === 'ArrowLeft') nextWidth -= event.shiftKey ? 48 : 16;
        else if (event.key === 'ArrowRight') nextWidth += event.shiftKey ? 48 : 16;
        else if (event.key === 'Home') nextWidth = 320;
        else if (event.key === 'End') nextWidth = this.agentPanelMaxWidth;
        else return;
        event.preventDefault();
        this.setAgentPanelWidth(nextWidth, true);
        void this.service.render();
    }

    public get agentDeviceRemaining() {
        const seconds = Math.max(0, Math.ceil((Number(this.agentDevice.expires_at || 0) * 1000 - Date.now()) / 1000));
        return `${Math.floor(seconds / 60)}분 ${String(seconds % 60).padStart(2, '0')}초 남음`;
    }

    public async refreshAgentStatus() {
        try {
            const response = await fetch('/api/ptsd/codex/status', { credentials: 'same-origin' });
            const result = await response.json();
            if (result.code !== 200) throw new Error(result.data?.message || '연결 상태를 확인하지 못했습니다.');
            this.agentRuntime = result.data || { connected: false };
            this.agentRuntimeError = '';
            if (this.agentRuntime.connected && Array.isArray(this.agentRuntime.models)) {
                this.applyAgentModels(this.agentRuntime.models);
            } else if (this.agentRuntime.connected) {
                await this.refreshAgentModels();
            } else {
                this.agentModels = [];
                this.agentModelNotice = '';
            }
        } catch (_error) {
            this.agentRuntimeError = '서버 연결 상태를 확인하지 못했습니다.';
        }
        void this.service.render();
    }

    public async refreshAgentModels() {
        if (this.agentModelsLoading) return;
        this.agentModelsLoading = true;
        try {
            const response = await fetch('/api/ptsd/codex/models', { credentials: 'same-origin' });
            const result = await response.json();
            if (result.code !== 200 || !Array.isArray(result.data?.models)) throw new Error('모델 목록 응답이 올바르지 않습니다.');
            this.applyAgentModels(result.data.models);
            if (this.agentModels.length) this.agentRuntime.connected = true;
        } catch (_error) {
            this.agentModelNotice = this.agentModels.length
                ? '모델 목록을 새로 확인하지 못했습니다. 이전 목록을 표시합니다.'
                : '모델 목록을 확인하지 못했습니다. 다시 불러오기를 눌러주세요.';
        } finally {
            this.agentModelsLoading = false;
        }
        void this.service.render();
    }

    private applyAgentModels(rows: Array<{ slug: string; display_name: string }>) {
        const seen = new Set<string>();
        this.agentModels = rows.filter((item: any) => {
            if (typeof item?.slug !== 'string' || typeof item?.display_name !== 'string'
                || !/^[a-z0-9][a-z0-9._-]{1,79}$/.test(item.slug) || seen.has(item.slug)) return false;
            seen.add(item.slug);
            return true;
        });
        this.agentModelNotice = this.agentModels.length ? '' : '선택 가능한 모델이 없습니다. 목록을 다시 불러와주세요.';
        if (this.agentSelectedModel && !this.agentModels.some((item) => item.slug === this.agentSelectedModel)) {
            this.agentSelectedModel = '';
            this.agentModelNotice = '이전에 선택한 모델을 사용할 수 없어 기본 모델로 변경했습니다.';
            try { window.localStorage.removeItem(this.agentModelStorageKey()); } catch (_error) { /* Ignore storage errors. */ }
        }
    }

    public onAgentModelChange(event: Event) {
        const selected = String((event.target as HTMLSelectElement)?.value || '');
        if (selected && !this.agentModels.some((item) => item.slug === selected)) return;
        this.agentSelectedModel = selected;
        this.agentModelNotice = '';
        try { window.localStorage.setItem(this.agentModelStorageKey(), selected); }
        catch (_error) { /* Model selection still works when storage is unavailable. */ }
        void this.service.render();
    }

    private formatAgentDate(date: Date = new Date()) {
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric', month: 'long', day: 'numeric', weekday: 'short', timeZone: 'Asia/Seoul'
        }).format(date);
    }

    private formatAgentTime(date: Date = new Date()) {
        return new Intl.DateTimeFormat('ko-KR', {
            hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Asia/Seoul'
        }).format(date);
    }

    private agentMessageId() {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    }

    private async loadCurrentAgentConversation() {
        try {
            const response = await fetch('/api/ptsd/codex/conversations/current', { credentials: 'same-origin' });
            const result = await response.json();
            if (result.code !== 200 || !result.data?.conversation?.id) throw new Error('대화를 불러오지 못했습니다.');
            this.agentConversationId = String(result.data.conversation.id);
            this.agentConversationTitle = String(result.data.conversation.title || '새 채팅');
            this.agentConversationError = '';
            await this.loadAgentHistory();
            await this.refreshAgentImageRuns();
        } catch (_error) {
            this.agentConversationError = '채팅을 불러오지 못했습니다. 페이지를 새로고침해 주세요.';
            void this.service.render();
        }
    }

    private resetAgentConversation(conversation: { id: string; title?: string }) {
        this.agentImageRunSequence++;
        if (this.agentImagePollTimer) clearTimeout(this.agentImagePollTimer);
        this.agentImagePollTimer = null;
        this.agentImageRuns = [];
        this.agentImageRunError = '';
        this.agentImageRunsLoading = false;
        this.agentHistoryLoadSequence++;
        this.agentHistoryLoading = false;
        this.agentConversationId = String(conversation.id);
        this.agentConversationTitle = String(conversation.title || '새 채팅');
        this.agentMessages = [];
        this.agentHistoryHasMore = false;
        this.agentHistoryBefore = null;
        this.agentHistoryError = '';
        this.agentDraft = '';
        this.agentAttachments = [];
        this.agentAttachmentError = '';
        this.agentConversationError = '';
    }

    public async startNewAgentConversation() {
        if (this.agentSending || this.agentRepairing || this.agentConversationChanging || this.agentHistoryDeleting) return;
        this.agentConversationChanging = true;
        this.agentConversationError = '';
        try {
            await this.agentSaveQueue;
            if (this.agentUnsavedMessages.length) throw new Error('저장에 실패한 대화가 있습니다. 먼저 다시 저장해주세요.');
            const result: any = await this.service.request.post('/api/ptsd/codex/conversations/new', {
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200 || !result.data?.conversation?.id) {
                throw new Error(result.data?.message || '새 채팅을 시작하지 못했습니다.');
            }
            this.resetAgentConversation(result.data.conversation);
            this.agentHistoryPanelOpen = false;
            this.agentHistorySearchSequence++;
            if (this.agentHistorySearchTimer) clearTimeout(this.agentHistorySearchTimer);
            this.agentHistorySearch = '';
            this.agentHistoryConversations = [];
            this.scrollAgentConversation();
        } catch (error) {
            this.agentConversationError = error instanceof Error ? error.message : '새 채팅을 시작하지 못했습니다.';
        } finally {
            this.agentConversationChanging = false;
            void this.service.render();
        }
    }

    public async openAgentConversation(conversation: AgentConversationSummary) {
        if (this.agentSending || this.agentRepairing || this.agentConversationChanging || this.agentHistoryDeleting) return;
        this.agentConversationChanging = true;
        this.agentConversationError = '';
        try {
            await this.agentSaveQueue;
            if (this.agentUnsavedMessages.length) throw new Error('저장에 실패한 대화가 있습니다. 먼저 다시 저장해주세요.');
            const result: any = await this.service.request.post('/api/ptsd/codex/conversations/open', {
                conversation_id: conversation.id,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200 || !result.data?.conversation?.id) {
                throw new Error(result.data?.message || '대화를 열지 못했습니다.');
            }
            this.resetAgentConversation(result.data.conversation);
            this.agentHistoryPanelOpen = false;
            this.agentHistorySearchSequence++;
            if (this.agentHistorySearchTimer) clearTimeout(this.agentHistorySearchTimer);
            this.agentHistorySearch = '';
            await this.loadAgentHistory();
            await this.refreshAgentImageRuns();
            this.scrollAgentConversation();
        } catch (error) {
            this.agentConversationError = error instanceof Error ? error.message : '대화를 열지 못했습니다.';
        } finally {
            this.agentConversationChanging = false;
            void this.service.render();
        }
    }

    public async loadAgentHistory(older: boolean = false) {
        if (!this.agentConversationId) return;
        if (older && (this.agentHistoryLoading || !this.agentHistoryHasMore)) return;
        const conversationId = this.agentConversationId;
        const sequence = ++this.agentHistoryLoadSequence;
        this.agentHistoryLoading = true;
        this.agentHistoryError = '';
        try {
            const params = new URLSearchParams({ conversation_id: conversationId });
            if (older && this.agentHistoryBefore) params.set('before', String(this.agentHistoryBefore));
            const response = await fetch(`/api/ptsd/codex/history?${params}`, { credentials: 'same-origin' });
            const result = await response.json();
            if (sequence !== this.agentHistoryLoadSequence || conversationId !== this.agentConversationId) return;
            if (result.code !== 200 || !Array.isArray(result.data?.messages)) {
                throw new Error(result.data?.message || '대화 기록을 불러오지 못했습니다.');
            }
            const incoming: AgentConversationMessage[] = result.data.messages.map((row: any) => {
                const date = new Date(`${String(row.created || '').replace(/Z$/, '')}Z`);
                const safeDate = Number.isNaN(date.getTime()) ? new Date() : date;
                return {
                    id: Number(row.id),
                    role: row.role === 'user' ? 'user' : 'agent',
                    text: String(row.text || ''),
                    time: this.formatAgentTime(safeDate),
                    date: this.formatAgentDate(safeDate),
                    clientId: String(row.client_id || ''),
                    conversationId,
                    previewAction: String(row.preview_action || '')
                };
            });
            const known = new Set(incoming.map((message) => message.clientId));
            const existing = older ? this.agentMessages : this.agentMessages.filter((message) =>
                message.role === 'progress' || !known.has(message.clientId)
            );
            this.agentMessages = older ? [...incoming, ...existing] : [...incoming, ...existing];
            this.agentHistoryHasMore = !!result.data.has_more;
            this.agentHistoryBefore = Number(result.data.next_before || 0) || null;
        } catch (_error) {
            if (sequence === this.agentHistoryLoadSequence) {
                this.agentHistoryError = '대화 기록을 불러오지 못했습니다. 다시 시도해주세요.';
            }
        } finally {
            if (sequence === this.agentHistoryLoadSequence) {
                this.agentHistoryLoading = false;
                void this.service.render();
            }
        }
    }

    public toggleAgentHistory() {
        if (this.agentSending || this.agentRepairing || this.agentHistoryDeleting || this.agentConversationChanging) return;
        this.agentHistoryPanelOpen = !this.agentHistoryPanelOpen;
        this.agentHistoryDeleteTarget = null;
        this.agentHistoryDeleteError = '';
        if (this.agentHistoryPanelOpen) {
            void this.loadAgentHistoryList();
            setTimeout(() => document.querySelector<HTMLInputElement>('.workbench-agent-history-search input')?.focus(), 0);
        } else {
            this.agentHistorySearchSequence++;
            if (this.agentHistorySearchTimer) clearTimeout(this.agentHistorySearchTimer);
            this.scrollAgentConversation();
        }
        void this.service.render();
    }

    public onAgentHistorySearchInput(event: Event) {
        this.agentHistorySearch = String((event.target as HTMLInputElement)?.value || '').slice(0, 80);
        if (this.agentHistorySearchTimer) clearTimeout(this.agentHistorySearchTimer);
        this.agentHistorySearchSequence++;
        this.agentHistoryConversations = [];
        this.agentHistoryListHasMore = false;
        this.agentHistoryDeleteTarget = null;
        this.agentHistoryDeleteError = '';
        this.agentHistoryListLoading = true;
        this.agentHistoryListError = '';
        this.agentHistorySearchTimer = setTimeout(() => void this.loadAgentHistoryList(), 300);
        void this.service.render();
    }

    public async loadAgentHistoryList(older: boolean = false) {
        if (older && (this.agentHistoryListLoading || !this.agentHistoryListHasMore)) return;
        const sequence = ++this.agentHistorySearchSequence;
        const term = this.agentHistorySearch.trim();
        if (!older) {
            this.agentHistoryConversations = [];
            this.agentHistoryListOffset = null;
            this.agentHistoryListHasMore = false;
            this.agentHistoryDeleteTarget = null;
        }
        this.agentHistoryListLoading = true;
        this.agentHistoryListError = '';
        void this.service.render();
        try {
            const params = new URLSearchParams();
            if (term) params.set('q', term);
            if (older && this.agentHistoryListOffset) params.set('offset', String(this.agentHistoryListOffset));
            const response = await fetch(`/api/ptsd/codex/conversations?${params}`, { credentials: 'same-origin' });
            const result = await response.json();
            if (result.code !== 200 || !Array.isArray(result.data?.conversations)) {
                throw new Error('대화 이력을 불러오지 못했습니다.');
            }
            if (sequence !== this.agentHistorySearchSequence || !this.agentHistoryPanelOpen) return;
            const conversations: AgentConversationSummary[] = result.data.conversations.map((row: any) => {
                const date = new Date(`${String(row.updated || '').replace(/Z$/, '')}Z`);
                const safeDate = Number.isNaN(date.getTime()) ? new Date() : date;
                return {
                    id: String(row.id), title: String(row.title || '새 채팅'),
                    preview: String(row.preview || ''), messageCount: Number(row.message_count || 0),
                    date: this.formatAgentDate(safeDate), time: this.formatAgentTime(safeDate)
                };
            });
            this.agentHistoryConversations = older ? [...this.agentHistoryConversations, ...conversations] : conversations;
            this.agentHistoryListHasMore = !!result.data.has_more;
            this.agentHistoryListOffset = Number(result.data.next_offset || 0) || null;
        } catch (_error) {
            if (sequence === this.agentHistorySearchSequence && this.agentHistoryPanelOpen) {
                this.agentHistoryListError = '대화 이력을 불러오지 못했습니다. 다시 시도해주세요.';
            }
        } finally {
            if (sequence === this.agentHistorySearchSequence) {
                this.agentHistoryListLoading = false;
                void this.service.render();
            }
        }
    }

    public isAgentHistoryDeleteArmed(conversation: AgentConversationSummary) {
        return this.agentHistoryDeleteTarget?.mode === 'conversation'
            && this.agentHistoryDeleteTarget.conversation?.id === conversation.id;
    }

    public requestAgentHistoryDelete(conversation?: AgentConversationSummary) {
        if (this.agentHistoryDeleting || this.agentHistoryListLoading) return;
        if (conversation && this.isAgentHistoryDeleteArmed(conversation)) {
            void this.confirmAgentHistoryDelete();
            return;
        }
        this.agentHistoryDeleteTarget = conversation ? { mode: 'conversation', conversation } : { mode: 'all' };
        this.agentHistoryDeleteError = '';
        void this.service.render();
        if (!conversation) setTimeout(() => document.getElementById('agent-history-delete-confirm')?.focus(), 0);
    }

    public cancelAgentHistoryDelete() {
        if (this.agentHistoryDeleting) return;
        this.agentHistoryDeleteTarget = null;
        this.agentHistoryDeleteError = '';
        void this.service.render();
    }

    public async confirmAgentHistoryDelete() {
        const target = this.agentHistoryDeleteTarget;
        if (!target || this.agentHistoryDeleting || this.agentSending || this.agentRepairing) return;
        this.agentHistoryDeleting = true;
        this.agentHistoryDeleteError = '';
        void this.service.render();
        try {
            await this.agentSaveQueue;
            if (this.agentUnsavedMessages.length) {
                throw new Error('저장에 실패한 대화가 있습니다. 대화 화면에서 다시 저장한 뒤 삭제해주세요.');
            }
            const result: any = await this.service.request.post(
                target.mode === 'all' ? '/api/ptsd/codex/history/delete' : '/api/ptsd/codex/conversations/delete', {
                ...(target.mode === 'all' ? { mode: 'all' } : { conversation_id: target.conversation?.id }),
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200) {
                throw new Error(result.data?.message || result.responseJSON?.data?.message || '대화 이력을 삭제하지 못했습니다.');
            }
            if (target.mode === 'all' || target.conversation?.id === this.agentConversationId) {
                if (result.data?.conversation?.id) this.resetAgentConversation(result.data.conversation);
            }
            if (target.mode === 'all') this.agentHistorySearch = '';
            this.agentHistorySearchSequence++;
            if (this.agentHistorySearchTimer) clearTimeout(this.agentHistorySearchTimer);
            this.agentHistoryConversations = [];
            this.agentHistoryListHasMore = false;
            this.agentHistoryListOffset = null;
            this.agentHistoryDeleteTarget = null;
            if (this.agentHistoryPanelOpen) await this.loadAgentHistoryList();
        } catch (error) {
            this.agentHistoryDeleteError = error instanceof Error ? error.message : '대화 이력을 삭제하지 못했습니다.';
        } finally {
            this.agentHistoryDeleting = false;
            void this.service.render();
        }
    }

    public setAgentPanelMode(mode: 'open' | 'collapsed' | 'closed') {
        const active = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        const leavingPanel = mode !== 'open' && !!active?.closest('.workbench-agent-panel');
        if (mode === 'open' && this.agentPanelMode !== 'open' && !active?.closest('.workbench-agent-panel')) {
            this.agentPanelReturnFocus = active;
        }
        if (mode !== 'open') {
            this.endAgentPanelResize();
            this.clearAgentPromptTarget();
            for (const message of this.agentMessages) {
                if (message.progress) message.progress.targetLinked = false;
            }
        }
        this.agentPanelMode = mode;
        if (mode === 'open') void this.refreshAgentStatus();
        void this.service.render();
        if (leavingPanel) window.setTimeout(() => {
            const origin = this.agentPanelReturnFocus;
            const selector = window.innerWidth < 1024 ? '.workbench-main'
                : mode === 'collapsed' ? '.workbench-agent-rail-expand' : '.workbench-agent-reopen';
            const target = origin?.isConnected && !origin.closest('.workbench-agent-panel')
                && origin !== document.body ? origin : document.querySelector<HTMLElement>(selector);
            target?.focus({ preventScroll: true });
        }, 0);
    }

    public showAgentRuntimeModal() {
        if (!this.isAgentAdmin) return;
        this.agentRuntimeReturnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.agentRuntimeModalVisible = true;
        this.agentDeviceCodeCopied = false;
        void this.refreshAgentStatus();
        void this.refreshAgentDeviceState();
        if (this.agentStatusTimer) clearInterval(this.agentStatusTimer);
        this.agentStatusTimer = setInterval(() => void this.refreshAgentDeviceState(), 3000);
        void this.service.render();
        setTimeout(() => document.querySelector<HTMLElement>('[data-agent-runtime-close="true"]')?.focus(), 0);
    }

    public closeAgentRuntimeModal() {
        this.agentRuntimeModalVisible = false;
        if (this.agentStatusTimer) clearInterval(this.agentStatusTimer);
        this.agentStatusTimer = null;
        void this.service.render();
        const returnFocus = this.agentRuntimeReturnFocus;
        this.agentRuntimeReturnFocus = null;
        setTimeout(() => returnFocus?.focus(), 0);
    }

    public onAgentRuntimeKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            this.closeAgentRuntimeModal();
            return;
        }
        if (event.key !== 'Tab') return;
        const dialog = document.querySelector<HTMLElement>('.workbench-agent-runtime-modal');
        if (!dialog) return;
        const controls = Array.from(dialog.querySelectorAll<HTMLElement>('button:not([disabled]), a[href]'))
            .filter((element) => element.offsetParent !== null);
        if (controls.length === 0) return;
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public async refreshAgentDeviceState() {
        if (!this.agentRuntimeModalVisible || !this.isAgentAdmin) return;
        try {
            const response = await fetch('/api/ptsd/codex/device/status', { credentials: 'same-origin' });
            const result = await response.json();
            if (result.code !== 200) throw new Error(result.data?.message || '인증 상태를 확인하지 못했습니다.');
            this.agentDevice = result.data || { state: 'idle' };
            if (this.agentDevice.state === 'connected') await this.refreshAgentStatus();
            this.agentRuntimeError = '';
        } catch (_error) {
            this.agentRuntimeError = '인증 상태를 확인하지 못했습니다.';
        }
        void this.service.render();
    }

    public async startAgentDeviceLogin(restart: boolean = false) {
        if (!this.isAgentAdmin) return;
        this.agentRuntimeError = '';
        this.agentDevice = { state: 'starting' };
        void this.service.render();
        const result: any = await this.service.request.post('/api/ptsd/codex/device/start', {
            csrf_token: this.service.auth.session?.csrf_token || '',
            restart: restart ? '1' : '0'
        });
        if (result.code === 200) {
            this.agentDevice = result.data || { state: 'starting' };
            if (this.agentDevice.state === 'busy') this.agentRuntimeError = '다른 관리자가 이 서버의 계정을 연결하고 있습니다.';
        } else {
            this.agentRuntimeError = result.data?.message || result.responseJSON?.data?.message || '디바이스 인증을 시작하지 못했습니다.';
            this.agentDevice = { state: 'failed' };
        }
        void this.service.render();
    }

    public async copyAgentDeviceCode() {
        if (!this.isAgentAdmin || !this.agentDevice.user_code) return;
        try {
            await navigator.clipboard.writeText(this.agentDevice.user_code);
            this.agentDeviceCodeCopied = true;
            void this.service.render();
            setTimeout(() => { this.agentDeviceCodeCopied = false; void this.service.render(); }, 2500);
        } catch (_error) {
            this.agentRuntimeError = '코드를 복사하지 못했습니다. 화면의 코드를 직접 입력해주세요.';
            void this.service.render();
        }
    }

    public async logoutAgentRuntime() {
        if (!this.isAgentAdmin || !this.agentRuntime.connected) return;
        if (!window.confirm('서버 공용 Codex 계정에서 로그아웃할까요? 모든 사용자의 에이전트 응답이 중단됩니다.')) return;
        const result: any = await this.service.request.post('/api/ptsd/codex/logout', {
            csrf_token: this.service.auth.session?.csrf_token || ''
        });
        if (result.code !== 200) {
            this.agentRuntimeError = result.data?.message || result.responseJSON?.data?.message || '로그아웃하지 못했습니다.';
        } else {
            await this.refreshAgentStatus();
            this.agentDevice = { state: 'idle' };
        }
        void this.service.render();
    }

    public onAgentDraftInput(event: Event) {
        this.agentDraft = (event.target as HTMLInputElement)?.value || '';
        void this.service.render();
    }

    public openAgentFilePicker() {
        document.getElementById('workbench-agent-files')?.click();
    }

    public onAgentFilesSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const chosen = Array.from(input.files || []);
        input.value = '';
        if (!chosen.length) return;
        const allowed = new Set([
            'txt', 'md', 'json', 'csv', 'pdf', 'xlsx', 'docx',
            'hwp', 'hwpx', 'png', 'jpg', 'jpeg', 'webp'
        ]);
        const files = [...this.agentAttachments, ...chosen];
        if (files.length > 4) {
            this.agentAttachmentError = '파일은 한 번에 최대 4개까지 첨부할 수 있습니다.';
        } else if (files.some((file) => !allowed.has(file.name.split('.').pop()?.toLowerCase() || ''))) {
            this.agentAttachmentError = '지원하는 파일은 문서, 표, 이미지 형식입니다.';
        } else if (files.some((file) => file.size === 0 || file.size > 8_000_000)
            || files.reduce((sum, file) => sum + file.size, 0) > 20_000_000) {
            this.agentAttachmentError = '파일은 각각 8MB, 합계 20MB 이하여야 합니다.';
        } else {
            this.agentAttachments = files;
            this.agentAttachmentError = '';
        }
        void this.service.render();
    }

    public removeAgentFile(index: number) {
        this.agentAttachments = this.agentAttachments.filter((_file, position) => position !== index);
        this.agentAttachmentError = '';
        void this.service.render();
    }

    private appendAgentMessage(role: 'user' | 'agent', text: string, previewAction?: string,
                               repair?: AgentConversationMessage['repair']): Promise<void> {
        const message: AgentConversationMessage = {
            role, text, previewAction, repair, clientId: this.agentMessageId(),
            conversationId: this.agentConversationId,
            date: this.formatAgentDate(), time: this.formatAgentTime()
        };
        if (role === 'user' && this.agentConversationTitle === '새 채팅') {
            this.agentConversationTitle = text.slice(0, 160);
        }
        this.agentMessages = [...this.agentMessages, message];
        this.agentUnsavedMessages.push(message);
        const saved = this.persistAgentMessage(message);
        this.scrollAgentConversation();
        return saved.catch(() => { /* The visible retry control handles failed saves. */ });
    }

    public agentDownloadUrl(previewAction?: string): string {
        if (!previewAction?.startsWith('download:')) return '';
        const path = previewAction.slice('download:'.length);
        if (!path.startsWith('/api/ptsd/content/archive?') || path.length > 190) return '';
        try {
            const url = new URL(path, window.location.origin);
            if (url.origin !== window.location.origin || url.pathname !== '/api/ptsd/content/archive') return '';
            const params = url.searchParams;
            if (![...params.keys()].every(key => ['scenario_set_id', 'memory_kind', 'scope', 'model'].includes(key))
                || !/^(?:[A-Z]{2}-[0-9]{2}|[A-Z][0-9]{2}|IM[0-9A-F]{14})$/.test(params.get('scenario_set_id') || '')
                || !['trauma', 'positive'].includes(params.get('memory_kind') || '')
                || !['scenario', 'model'].includes(params.get('scope') || '')
                || (params.get('scope') === 'model' && !/^[a-z0-9][a-z0-9._-]{1,79}$/.test(params.get('model') || ''))
                || (params.get('scope') === 'scenario' && params.has('model'))) return '';
            return path;
        } catch (_error) { return ''; }
    }

    private persistAgentMessage(message: AgentConversationMessage): Promise<void> {
        const save = async () => {
            const result: any = await this.service.request.post('/api/ptsd/codex/history/message', {
                client_id: message.clientId,
                role: message.role,
                text: message.text,
                preview_action: message.previewAction || '',
                conversation_id: message.conversationId,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200) throw new Error('대화 내용을 저장하지 못했습니다.');
            this.agentUnsavedMessages = this.agentUnsavedMessages.filter((item) => item !== message);
            if (!this.agentUnsavedMessages.length) this.agentHistoryError = '';
        };
        const pending = this.agentSaveQueue.then(save);
        this.agentSaveQueue = pending.catch(() => {
            this.agentHistoryError = '대화 저장에 실패했습니다. 다시 저장을 눌러주세요.';
            void this.service.render();
        });
        return pending;
    }

    public async retryAgentMessageSave() {
        const pending = [...this.agentUnsavedMessages];
        if (!pending.length) {
            await this.loadAgentHistory();
            return;
        }
        for (const message of pending) {
            try { await this.persistAgentMessage(message); }
            catch (_error) { break; }
        }
    }

    private scrollAgentConversation() {
        void this.service.render();
        setTimeout(() => {
            const conversation = document.getElementById('workbench-agent-scroll-region');
            if (conversation) conversation.scrollTop = conversation.scrollHeight;
        }, 0);
    }

    private agentCurrentPageLabel() {
        const path = window.location.pathname;
        if (WorkspaceScreenAgent.pageLabel(path)) return `현재 화면 · ${WorkspaceScreenAgent.pageLabel(path)}`;
        if (path.startsWith('/content')) return '현재 화면 · 콘텐츠 워크벤치';
        if (path.startsWith('/prompts')) return '현재 화면 · 생성 기준';
        if (path.startsWith('/dashboard')) return '현재 화면 · 대시보드';
        if (path.startsWith('/patients')) return '현재 화면 · 환자 관리';
        if (path.startsWith('/schedule')) return '현재 화면 · 일정 관리';
        return '현재 화면 · 워크벤치';
    }

    private clearAgentPromptTarget() {
        this.agentPromptTarget?.classList.remove('workbench-agent-prompt-target');
        this.agentPromptTarget = null;
    }

    private locateAgentPromptTarget(text: string) {
        this.clearAgentPromptTarget();
        if (this.isAgentReadQuestion(text)) return null;
        const intensity = /강도(?:별\s*조정)?\s*([1-5])/.exec(text)?.[1];
        if (!intensity || !text.includes('프롬프트') || !window.location.pathname.startsWith('/content')) return null;
        const field = document.getElementById(`wb-intensity-prompt-${intensity}`);
        if (!(field instanceof HTMLTextAreaElement) || !field.getClientRects().length) return null;
        field.classList.add('workbench-agent-prompt-target');
        this.agentPromptTarget = field;
        return `강도 ${intensity}`;
    }

    private isAgentReadQuestion(text: string) {
        return (/[?？]\s*$/.test(text) || /안\s*되는데|같은데|들어갔거든|문제/.test(text))
            && !/(?:해|넣어|바꿔|수정해|삭제해|저장해|생성해|선택해|적용해|업로드해|추가해|지워|만들어|뽑아|그려|보여|열어|닫아)\s*(?:줘|주세요|줄래|줄\s*수|주실\s*수|주시겠|주겠)/.test(text);
    }

    private isAgentOperationalIssue(text: string) {
        return /왜|오류|실패|원인|진단|이상|문제|누락|동기화|반영.*안|안.*반영|안.*보이|안.*나오|보이지 않|나오지 않|작동하지 않|데이터.*(없|안)|DB|db/.test(text)
            || /(상태|작업|등록|업로드|시나리오|목록).*(확인|조사|점검)/.test(text);
    }

    private isAgentPromptEditRequest(text: string) {
        const target = /(강도|트리거|블러|사실적 묘사|공통 장면|모델별).*(프롬프트|지시)/.test(text)
            || /프롬프트.*(강도|트리거|블러|사실적 묘사|공통 장면|모델별)/.test(text);
        return target && /(수정|바꿔|채워|작성|넣어|지워|삭제|추가|고쳐)/.test(text)
            && !/오류|실패|저장.*안|안.*저장|새로고침.*날아|반영.*안|안.*반영/.test(text);
    }

    private isImageAgentRequest(text: string, context: any, attachments: File[] = []): boolean {
        if (this.isScenarioImportRequest(text, attachments)) return false;
        const customExpression = /^(?:custom|single_custom):/.test(String(context?.expression || ''));
        const builtinTransition = /(?:사실적\s*묘사|트리거(?:\s*요소)?|블러|realistic|trigger|blur)\s*(?:표현\s*)?(?:으로|로)\s*(?:바꿔|변경|전환|선택|이미지|생성|만들)/i.test(text)
            || /(?:사실적\s*묘사|트리거(?:\s*요소)?|블러)\s*(?:강도\s*[1-5]\s*)?(?:이미지\s*)?(?:생성|재생성|만들|그려|뽑)/.test(text)
            || /(?:사실적\s*묘사|블러)\s*강도\s*[1-5]/.test(text) && /생성|재생성|만들|그려|뽑/.test(text);
        const preparedPlanCommand = /그\s*계획.*(?:재생성|생성|실행|만들)/.test(text)
            && this.agentImageRuns.some((run) => run.status === 'plan_ready');
        if (customExpression && !builtinTransition && !preparedPlanCommand) return false;
        const negatedStage = /(?:재생성|생성|분석|평가|제작|보정)\s*(?:은\s*|는\s*)?(?:하지\s*마|하지\s*말|은\s*하지)/g;
        const affirmative = text.replace(negatedStage, '');
        if (affirmative !== text && !/(?:재생성|생성|분석|평가|제작|보정)(?:\s*계획)?\s*(?:만\s*)?(?:해|진행해|만들어|보여|작성|정리|세워)|그\s*계획.*(?:생성|만들|실행)/.test(affirmative)) return false;
        const explicitImage = /이미지|사진|그림/.test(text);
        if (/audio|video/.test(String(context?.kind || '')) && !explicitImage) return false;
        if (/프롬프트/.test(text) && (!explicitImage || /이미지\s*프롬프트(?:만|를)?\s*(?:생성|만들|작성)/.test(text))
            && /프롬프트.*(?:생성|만들|작성)/.test(text)) return false;
        if (/음향|오디오|음성|영상|비디오|동영상/.test(text) && !explicitImage) return false;
        if (/프롬프트/.test(text) && /수정|작성|바꿔|지워|넣어|채워/.test(text)
            && !/생성|재생성|이미지.*평가|이미지.*검사/.test(text)) return false;
        const execute = /(?:해|진행|만들어|그려|뽑아|돌려|부탁|시작|맡길|맡겨|생성|평가|분석|검사|보정|계획)/.test(text);
        const actionable = /해\s*줘|해\s*주세|해줄래|해\s*줄래|해주면|만들어|그려|뽑아|진행해|시작해|돌려|맡겨|부탁|수정해|고쳐/.test(text);
        if (/어떻게|뭐야|무엇|방법|가능해|되나요/.test(text) && !actionable) return false;
        if (/왜|원인|에러|오류|안\s*(?:돼|되)|작동하지/.test(text)
            && !/(?:생성|재생성|평가|분석|보정)\s*(?:해|하|진행|부탁)|만들어|그려|뽑아|맡겨/.test(text)) return false;
        if (!execute || (this.isAgentReadQuestion(text) && !actionable)) return false;
        if (preparedPlanCommand) return true;
        if (explicitImage && /생성|재생성|만들|그려|뽑|평가|검사|분석|보정|수정|고쳐|반영|다시/.test(text)) return true;
        const imageScope = context?.kind === 'scenario_image_prompt' && !!context.scenario_id
            || !window.location.pathname.startsWith('/content')
                && this.agentImageRuns.some((run) => run.result_images?.length || run.status === 'plan_ready');
        if (imageScope && /(?:생성|평가|보정|수정\s*계획)\s*(?:계획)?\s*(?:만\s*)?(?:해|진행|세워|만들|작성|보여|정리|$)|그\s*계획.*(?:생성|실행|만들)|방금.*(?:평가|보정|재생성)/.test(text)) return true;
        if (/시나리오|컷\s*\d|\d+\s*컷/.test(text)
            && /분석|생성|처음부터|끝까지|자동/.test(text)) return true;
        const selectedScenario = context?.kind === 'scenario_image_prompt' && !!context.scenario_id;
        return selectedScenario && !this.isAgentPromptEditRequest(text)
            && /재생성|다시\s*(?:생성|만들|그려|뽑)|(?:분석|평가|보정)\s*해/.test(text);
    }

    private imageAgentContext(context: any): any {
        const page = this.agentPageContext();
        const result = { ...(context || {}), page_context: page };
        if (!result.scenario_id && page.scenario_id) result.scenario_id = page.scenario_id;
        const previous = this.agentImageRuns.find((run) => !this.imageAgentRunActive(run)
            && (!result.scenario_id || run.scenario_id === result.scenario_id)
            && (!result.cut_order || Number(run.cut_order) === Number(result.cut_order))
            && (!result.memory_kind || !run.memory_kind || run.memory_kind === result.memory_kind));
        if (previous) result.previous_image_agent_run_id = previous.id;
        const seen = new Set<string>();
        const imageCandidates = this.agentImageRuns.flatMap((run) =>
            (Array.isArray(run.result_images) ? [...run.result_images].reverse() : []).map((image: any) => ({
                source_run_id: run.id, asset_revision_id: image.revision_id || image.asset_revision_id,
                scenario_id: image.scenario_id || run.scenario_id, cut_order: image.cut_order || run.cut_order,
                memory_kind: image.memory_kind || run.memory_kind, expression: image.expression || run.expression,
                intensity: image.intensity, model_id: image.model_id || run.model_id,
                label: String(image.label || '').slice(0, 240), source_run_active: this.imageAgentRunActive(run),
                generated_at: image.generated_at || null, is_new_generation: image.is_new_generation === true,
                source_run_operation: run.operation || '', source_run_updated_at: run.updated_at || null
            })));
        const generatedTime = (image: any) => {
            const value = image.generated_at;
            if (typeof value === 'number') return Number.isFinite(value) ? (value < 1e12 ? value * 1000 : value) : 0;
            const parsed = Date.parse(String(value || ''));
            return Number.isFinite(parsed) ? parsed : 0;
        };
        imageCandidates.sort((a: any, b: any) => Number(b.is_new_generation) - Number(a.is_new_generation)
            || generatedTime(b) - generatedTime(a));
        result.recent_image_agent_results = imageCandidates.filter((image: any) => {
                const id = String(image.asset_revision_id || '');
                if (!/^[a-f0-9]{32}$/.test(id) || seen.has(id)) return false;
                seen.add(id); return true;
            }).slice(0, 12);
        result.prepared_repair_runs = this.agentImageRuns.filter((run) => run.status === 'plan_ready')
            .map((run) => ({ run_id: run.id, plan_id: run.repair_plan?.plan_id,
                asset_revision_id: run.repair_plan?.asset_revision_id || run.result_images?.slice(-1)[0]?.revision_id,
                scenario_id: run.scenario_id, cut_order: run.cut_order, memory_kind: run.memory_kind,
                model_id: run.tasks?.slice(-1)[0]?.model_id, status: run.status }))
            .filter((plan) => !!plan.plan_id && /^[a-f0-9]{32}$/.test(String(plan.asset_revision_id || ''))).slice(0, 6);
        return result;
    }

    public imageAgentRunActive(run: any): boolean {
        return !['completed', 'generated', 'plan_ready', 'needs_review', 'failed', 'cancelled'].includes(String(run?.status || ''));
    }

    public trackImageAgentRun(_index: number, run: any): string { return run.id; }
    public trackImageAgentImage(index: number, image: any): string { return String(image.revision_id || image.job_id || index); }

    public imageAgentRunStage(run: any): string {
        const stages: { [key: string]: string } = {
            planning: '요청과 생성 조건 확인', analyzing: '시나리오·컷 분석',
            generating: '이미지 생성', evaluating: '실제 이미지 평가', repairing: '보정 계획 작성',
            regenerating: '조건을 유지한 재생성', queued: '실행 대기', completed: '작업 완료',
            needs_review: '확인 필요', failed: '실행 실패', cancelled: '중지됨',
            generated: '생성 완료 · 평가 대기', plan_ready: '보정 계획 준비 · 재생성 요청 대기'
        };
        if (!this.imageAgentRunActive(run)) return stages[String(run.status)] || '작업 종료';
        return stages[String(run.stage || run.status)] || '이미지 작업 진행 중';
    }

    public imageAgentContentUrl(run: any, cut: any = null): string {
        const scenario = String(run?.scenario_id || '').toUpperCase();
        if (!/^(?:[A-Z]{2}-[0-9]{2}|[A-Z][0-9]{2}|IM[0-9A-F]{14})$/.test(scenario)) return '';
        const memory = String(cut?.memory_kind || run?.memory_kind || 'trauma');
        if (!['trauma', 'positive'].includes(memory)) return '';
        const params = new URLSearchParams({ source: 'scenario', scenario, memory });
        const order = Number(cut?.order || run?.cut_order || 0);
        if (Number.isInteger(order) && order >= 1 && order <= 12) params.set('cut', String(order));
        return `/content?${params}`;
    }

    public imageAgentCriteria(run: any): any[] {
        const attempts = Array.isArray(run?.attempts) ? run.attempts : [];
        const evaluation = run?.evaluation || attempts.slice().reverse().find((item: any) => item?.evaluation)?.evaluation;
        const criteria = evaluation?.criteria;
        return Array.isArray(criteria) ? criteria.slice(0, 128) : [];
    }

    public imageAgentCriterionLabel(criterion: any): string {
        return ({ passed: '통과', failed: '미충족', unknown: '판단 불가', not_evaluated: '항목별 미평가' } as { [key: string]: string })
            [String(criterion?.status)] || '평가 대기';
    }

    public imageAgentTriggerPoints(run: any): any[] {
        return Array.isArray(run?.trigger_points) ? run.trigger_points.slice(0, 24) : [];
    }

    public imageAgentEvaluationSummary(run: any): string {
        const criteria = this.imageAgentCriteria(run);
        const count = (status: string) => criteria.filter((item: any) => item.status === status).length;
        return `평가 ${criteria.length}개 · 통과 ${count('passed')} · 미충족 ${count('failed')} · 판단 불가 ${count('unknown')}`;
    }

    public imageAgentEvidence(criterion: any): string {
        return (Array.isArray(criterion?.evidence) ? criterion.evidence.join(' · ')
            : String(criterion?.evidence || criterion?.observation || '')).slice(0, 1400);
    }

    public imageAgentRepairPlan(run: any): any {
        const attempts = Array.isArray(run?.attempts) ? run.attempts : [];
        return run?.repair_plan || attempts.slice().reverse().find((item: any) => item?.repair_plan)?.repair_plan || null;
    }

    public imageAgentPlanText(value: any): string {
        if (Array.isArray(value)) return value.map((item) => typeof item === 'string' ? item
            : String(item?.instruction || item?.description || item?.text || '')).filter(Boolean).join(' · ').slice(0, 1600);
        return typeof value === 'string' ? value.slice(0, 1600) : '';
    }

    public imageAgentImageUrl(image: any): string {
        const value = String(image?.url || image?.preview_url || '');
        if (!value || value.length > 8192) return '';
        try {
            const url = new URL(value, window.location.origin);
            return url.origin === window.location.origin && url.pathname.startsWith('/api/ptsd/')
                && !url.username && !url.password ? url.href : '';
        } catch (_error) { return ''; }
    }

    public imageAgentImageUnavailable(run: any, image: any): boolean {
        return this.agentImageUnavailable.has(`${run.id}:${image.revision_id || image.job_id || image.url}`);
    }

    public onImageAgentImageError(run: any, image: any) {
        this.agentImageUnavailable.add(`${run.id}:${image.revision_id || image.job_id || image.url}`);
        void this.service.render();
    }

    private checkedImageAgentRun(run: any): any | null {
        if (!run || typeof run !== 'object' || !/^[A-Za-z0-9_-]{1,128}$/.test(String(run.id || ''))
            || (run.conversation_id && run.conversation_id !== this.agentConversationId)) return null;
        return { ...run, attempts: Array.isArray(run.attempts) ? run.attempts : [],
            events: Array.isArray(run.events) ? run.events.slice(-60) : [],
            result_images: Array.isArray(run.result_images) ? run.result_images.slice(0, 24) : [] };
    }

    private registerImageAgentRun(value: any) {
        const run = this.checkedImageAgentRun(value);
        if (!run) throw new Error('등록된 이미지 작업을 확인하지 못했습니다. 대화의 작업 상태를 다시 불러와 주세요.');
        this.agentImageRunSequence++;
        this.agentImageRunsLoading = false;
        this.agentImageRuns = [run, ...this.agentImageRuns.filter((item) => item.id !== run.id)].slice(0, 12);
        this.scheduleImageAgentRefresh();
        this.scrollAgentConversation();
    }

    private scheduleImageAgentRefresh() {
        if (this.agentImagePollTimer) clearTimeout(this.agentImagePollTimer);
        this.agentImagePollTimer = null;
        if (!this.agentImageDestroyed && this.agentConversationId
            && (this.agentImageRunError || this.agentImageRuns.some((run) => this.imageAgentRunActive(run)))) {
            this.agentImagePollTimer = setTimeout(() => void this.refreshAgentImageRuns(), 2500);
        }
    }

    private refreshImageAgentScope(run: any) {
        if (!window.location.pathname.startsWith('/content') || !run.scenario_id) return;
        const current = this.agentPromptContext();
        if (!current || current.kind !== 'scenario_image_prompt'
            || current.scenario_id !== run.scenario_id
            || (run.memory_kind && current.memory_kind !== run.memory_kind)
            || Number(current.cut_order) !== Number(run.cut_order)) return;
        window.dispatchEvent(new CustomEvent('ptsd:agent:refresh-data', { detail: {
            image_agent_scope: { scenario_id: run.scenario_id, memory_kind: run.memory_kind, cut_order: run.cut_order }
        } }));
    }

    public async refreshAgentImageRuns() {
        if (this.agentImageDestroyed || !this.agentConversationId) return;
        const conversation = this.agentConversationId;
        const sequence = ++this.agentImageRunSequence;
        this.agentImageRunsLoading = true;
        try {
            const params = new URLSearchParams({ conversation_id: conversation });
            const result = await (await fetch(`/api/ptsd/codex/image-agent/runs?${params}`,
                { credentials: 'same-origin' })).json();
            if (sequence !== this.agentImageRunSequence || conversation !== this.agentConversationId) return;
            if (result.code !== 200 || !Array.isArray(result.data?.runs)) {
                // A missing feature on an older deployment should not break ordinary chat.
                if (result.code === 404 && !this.agentImageRuns.length) return;
                throw new Error(result.data?.message || '이미지 작업 상태를 불러오지 못했습니다.');
            }
            const prior = new Map(this.agentImageRuns.map((run) => [run.id, run]));
            this.agentImageRuns = result.data.runs.map((run: any) => this.checkedImageAgentRun(run)).filter(Boolean).slice(0, 12);
            this.agentImageRunError = '';
            for (const run of this.agentImageRuns) {
                const previous: any = prior.get(run.id);
                if (previous && this.imageAgentRunActive(previous) && !this.imageAgentRunActive(run)) {
                    this.refreshImageAgentScope(run);
                }
            }
        } catch (_error) {
            if (sequence === this.agentImageRunSequence) this.agentImageRunError = '이미지 작업 상태를 불러오지 못했습니다. 서버 작업은 계속될 수 있으며 다시 확인합니다.';
        } finally {
            if (sequence === this.agentImageRunSequence && conversation === this.agentConversationId) {
                this.agentImageRunsLoading = false;
                this.scheduleImageAgentRefresh();
                void this.service.render();
            }
        }
    }

    public async refreshAgentImageRun(run: any) {
        if (!run?.id) return;
        const conversation = this.agentConversationId;
        try {
            const params = new URLSearchParams({ run_id: run.id, conversation_id: conversation });
            const result = await (await fetch(`/api/ptsd/codex/image-agent/run?${params}`,
                { credentials: 'same-origin' })).json();
            if (conversation !== this.agentConversationId) return;
            if (result.code !== 200) throw new Error();
            this.registerImageAgentRun(result.data?.run);
            for (const key of this.agentImageUnavailable) if (key.startsWith(`${run.id}:`)) this.agentImageUnavailable.delete(key);
            this.agentImageRunError = '';
        } catch (_error) {
            if (conversation === this.agentConversationId) this.agentImageRunError = '이미지 작업과 미리보기를 다시 불러오지 못했습니다. 다시 시도해주세요.';
        }
        void this.service.render();
    }

    public imageAgentCancelling(run: any): boolean { return this.agentImageCancelling.has(run.id); }

    public async cancelAgentImageRun(run: any) {
        if (!this.imageAgentRunActive(run) || this.agentImageCancelling.has(run.id)) return;
        this.agentImageCancelling.add(run.id);
        const conversation = this.agentConversationId;
        try {
            const result: any = await this.service.request.post('/api/ptsd/codex/image-agent/cancel', {
                run_id: run.id, conversation_id: conversation, csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (conversation !== this.agentConversationId) return;
            if (result.code !== 200) throw new Error();
            if (result.data?.run) this.registerImageAgentRun(result.data.run);
            else await this.refreshAgentImageRuns();
            this.agentImageRunError = '';
        } catch (_error) {
            if (conversation === this.agentConversationId) this.agentImageRunError = '서버의 작업 중지를 확인하지 못했습니다. 상태를 다시 불러온 뒤 확인해주세요.';
        } finally {
            this.agentImageCancelling.delete(run.id);
            void this.service.render();
        }
    }

    private appendAgentProgress(text: string): AgentConversationMessage {
        const targetLabel = this.locateAgentPromptTarget(text);
        const message: AgentConversationMessage = {
            role: 'progress', text: '', time: this.formatAgentTime(), date: this.formatAgentDate(),
            progress: {
                state: 'running', title: '현재 화면을 확인하는 중',
                context: targetLabel ? '콘텐츠 워크벤치 · 적용 프롬프트' : this.agentCurrentPageLabel(),
                expanded: true, targetLinked: !!targetLabel,
                steps: [
                    { label: '요청 접수 완료', state: 'done' },
                    { label: '현재 화면 확인 중', state: 'active' }
                ]
            }
        };
        this.agentMessages = [...this.agentMessages, message];
        this.scrollAgentConversation();
        return message;
    }

    private advanceAgentProgress(message: AgentConversationMessage, completedLabel: string, nextLabel: string) {
        const progress = message.progress;
        if (!progress || progress.state !== 'running') return;
        const active = progress.steps.find((step) => step.state === 'active');
        if (active) {
            active.label = completedLabel;
            active.state = 'done';
        }
        progress.steps.push({ label: nextLabel, state: 'active' });
        progress.title = nextLabel;
        this.scrollAgentConversation();
    }

    private finishAgentProgress(message: AgentConversationMessage, succeeded: boolean, title?: string, finalLabel?: string) {
        const progress = message.progress;
        if (!progress || progress.state !== 'running') return;
        progress.state = succeeded ? 'complete' : 'failed';
        progress.title = title || (succeeded ? '응답 완료' : '응답을 받지 못했습니다');
        const active = progress.steps.find((step) => step.state === 'active');
        if (active) {
            active.label = finalLabel || (succeeded
                ? active.label.replace(/\s*중$/, '') + ' 완료' : active.label.replace(/\s*중$/, '') + ' 실패');
            active.state = succeeded ? 'done' : 'failed';
        } else if (finalLabel) {
            progress.steps.push({ label: finalLabel, state: succeeded ? 'done' : 'failed' });
        }
        progress.targetLinked = false;
        this.clearAgentPromptTarget();
        this.scrollAgentConversation();
    }

    public toggleAgentProgress(message: AgentConversationMessage) {
        if (!message.progress) return;
        message.progress.expanded = !message.progress.expanded;
        void this.service.render();
    }

    public agentScopeDescription() {
        return window.location.pathname === '/ai/usage'
            ? 'AI 비용 · 현재 조회 조건의 사용량과 비용 질문에 답합니다.'
            : `${this.agentCurrentPageLabel().replace('현재 화면 · ', '')} · 화면 조회와 작업을 돕습니다.`;
    }

    private agentPromptContext(request: string = ''): any | null {
        if (!window.location.pathname.startsWith('/content')) return this.workspaceAgent.capture();
        if (/(?:이미지|오디오|음향|영상|비디오)\s*(?:탭|으로\s*(?:전환|바꿔|이동))|(?:다음|이전|\d+\s*번?)\s*컷.*(?:선택|이동|바꿔|보여)|(?:대시보드|환자(?:\s*관리)?|치료\s*세션|레퍼런스\s*자료실|시나리오\s*세트|프롬프트\s*관리|일정\s*관리|멤버\s*관리|감사\s*기록|내\s*프로필|AI\s*비용).*(?:메뉴|이동|열어|가줘|전환)/.test(request)) {
            return this.workspaceAgent.capture();
        }
        let context: any = null;
        window.dispatchEvent(new CustomEvent('ptsd:agent:prompt-context', {
            detail: { respond: (value: any) => { context = value; } }
        }));
        return context || this.workspaceAgent.capture();
    }

    private agentPageContext() {
        const path = window.location.pathname;
        const params = new URLSearchParams(window.location.search);
        let selection: { scenario_id?: string; uploaded_id?: string } | null = null;
        window.dispatchEvent(new CustomEvent('ptsd:agent:page-context', {
            detail: { respond: (value: any) => { selection = value; } }
        }));
        return {
            kind: 'workbench_page',
            path,
            scenario_id: selection?.scenario_id || params.get('scenario') || '',
            uploaded_id: selection?.uploaded_id || params.get('upload') || '',
            import_job: params.get('import_job') || ''
        };
    }

    private agentDiagnosticText(report: any): string {
        const lines = [String(report?.summary || '진단 결과를 확인하지 못했습니다.')];
        if (report?.cause) lines.push(`원인: ${String(report.cause)}`);
        const evidence = Array.isArray(report?.evidence) ? report.evidence : [];
        if (evidence.length) {
            lines.push('확인 근거:');
            for (const item of evidence.slice(0, 8)) {
                const data = item?.data || {};
                if (item?.id === 'scenario_uploads') lines.push(`• 등록된 내 시나리오 ${Number(data.count || 0)}건`);
                else if (item?.id === 'scenario_import_job') lines.push(data.visible === false
                    ? '• 검토 작업을 찾을 수 없음'
                    : `• 시나리오 분석 ${Number(data.analyzed || 0)}/${Number(data.count || 0)}건 · ${data.committed ? '등록 완료' : '등록 전 검토 상태'}`);
                else if (item?.id === 'content_sources') lines.push(`• 콘텐츠 출처 ${Number(data.count || 0)}건 · 목록 누락 ${Array.isArray(data.missing_ids) ? data.missing_ids.length : 0}건`);
                else if (item?.id === 'selected_source') lines.push(`• 선택한 출처 ${data.exists ? (data.analysis_only ? '등록됨 · 분석 전' : '사용 가능') : '서버 목록에서 확인되지 않음'}`);
                else if (item?.id === 'selected_scenario_facts') lines.push(data.available === false
                    ? '• 선택한 시나리오의 등록 내용을 찾지 못함'
                    : `• 선택한 시나리오 ${String(data.title || data.id || '')} · 등록된 대화 ${Number(data.dialogue_turn_count || 0)}턴${data.analysis_summary ? ' · 분석 요약 있음' : ''}`);
                else if (item?.id === 'generation_jobs') lines.push(`• 조회 가능한 생성 작업 ${Array.isArray(data.jobs) ? data.jobs.length : 0}건`);
                else if (item?.id === 'recent_errors') lines.push(`• 최근 실패 감사 기록 ${Array.isArray(data.events) ? data.events.length : 0}건`);
                else if (item?.id === 'audit_scope') lines.push('• 감사 기록은 현재 계정 권한으로 조회할 수 없음');
                else if (item?.id === 'patient_counts') lines.push(`• 권한 범위 환자 활성 ${Number(data.active || 0)}건 · 보관 ${Number(data.archived || 0)}건`);
                else if (item?.id === 'appointment_counts') lines.push(`• 향후 31일 일정 예정 ${Number(data.scheduled || 0)}건 · 완료 ${Number(data.completed || 0)}건`);
                else if (item?.id === 'template_counts') lines.push(`• 활성 생성 기준 ${Number(data.active || 0)}건 · 이미지 ${Number(data.image_active || 0)}건`);
                else if (item?.id === 'requested_job') lines.push(`• 지정 작업 ${data.visible ? `${data.job?.status || '상태 확인'}${data.job?.error_code ? ` · ${data.job.error_code}` : ''}` : '조회 권한 또는 기록 없음'}`);
                else if (item?.id === 'saved_draft') lines.push(`• 서버 초안 ${data.updated ? '저장 기록 있음' : '저장 기록 없음'}${data.matches_browser === null ? '' : data.matches_browser ? ' · 공통·강도 입력 일치' : ' · 공통·강도 입력 차이 있음'}`);
                else if (item?.id === 'browser_draft') lines.push('• 현재 입력 상태는 브라우저에서만 확인됨');
                else if (item?.id === 'screen') lines.push(`• 현재 화면 ${String(data.page || '')}`);
                else if (String(item?.id || '').endsWith('_error')) lines.push(`• ${String(item.label || '조회')} · 조회 실패`);
            }
        }
        if (report?.next_step) lines.push(`다음 단계: ${String(report.next_step)}`);
        if (report?.repair?.job_id) lines.push(`복구 대상 작업: ${String(report.repair.job_id)} · 실패 상태`);
        if (report?.repair?.cost_notice) lines.push(String(report.repair.cost_notice));
        return lines.join('\n');
    }

    public async executeAgentRepair(message: AgentConversationMessage) {
        const repair = message.repair;
        if (!repair || repair.done || repair.running || this.agentSending || this.agentRepairing
            || !this.agentConversationId || !this.service.auth.session?.csrf_token) return;
        this.agentRepairing = true;
        repair.running = true;
        const progress = this.appendAgentProgress('실패한 생성 작업 재시도');
        if (progress.progress) progress.progress.context = '생성 작업 · 재시도';
        void this.service.render();
        try {
            await this.appendAgentMessage('user', `${repair.label} 실행 · ${repair.job_id}`);
            this.advanceAgentProgress(progress, '복구 요청 접수 완료', '권한과 작업 상태 재확인 중');
            const payload = new FormData();
            payload.append('proposal_id', repair.id);
            payload.append('csrf_token', this.service.auth.session.csrf_token);
            const response = await fetch('/api/ptsd/codex/diagnose/repair', {
                method: 'POST', body: payload, credentials: 'same-origin'
            });
            const result: any = await response.json();
            if (result.code !== 200) throw new Error(result.data?.message || '복구를 완료하지 못했습니다.');
            repair.done = true;
            const verified = result.data?.result?.verified === true;
            this.finishAgentProgress(progress, verified,
                verified ? '재시도 실행·상태 확인 완료' : '재시도 후 상태 재확인 필요',
                verified ? `재시도 후 ${String(result.data?.result?.after?.status || '상태')} 확인 완료` : '작업 상태 확인 필요');
            await this.appendAgentMessage('agent', String(result.data?.result?.message || '작업 상태를 확인해주세요.'));
            if (verified) window.dispatchEvent(new CustomEvent('ptsd:agent:refresh-data'));
        } catch (error: any) {
            this.finishAgentProgress(progress, false, '복구를 완료하지 못했습니다', '작업 상태 재확인 실패');
            await this.appendAgentMessage('agent', String(error?.message || '복구를 완료하지 못했습니다.'));
        } finally {
            repair.running = false;
            this.agentRepairing = false;
            void this.service.render();
        }
    }

    private isScenarioImportRequest(text: string, files: File[]): boolean {
        if (!files.length) return false;
        const request = text.normalize('NFC');
        const asksToSave = /(업로드|등록|저장|추가|올려|넣어)/.test(request);
        return asksToSave && (/시나리오|scenario/i.test(request)
            || files.some((file) => /시나리오|scenario|대화\s*셋/i.test(file.name.normalize('NFC')))
            || window.location.pathname.startsWith('/scenario-sets'));
    }

    private presentScenarioImportJob(jobId: string, job?: any) {
        const route = `/scenario-sets?import_job=${encodeURIComponent(jobId)}`;
        if (!window.location.pathname.startsWith('/scenario-sets')) {
            this.service.href(route);
            return;
        }
        const url = new URL(location.href);
        url.searchParams.set('import_job', jobId);
        history.replaceState({}, '', `${url.pathname}${url.search}`);
        window.dispatchEvent(new CustomEvent('ptsd:agent:scenario-import-ready', {
            detail: { jobId, job }
        }));
    }

    private notifyAgentPromptActivity(phase: 'working' | 'inspected' | 'clear', request: string = '') {
        window.dispatchEvent(new CustomEvent('ptsd:agent:prompt-activity', {
            detail: { phase, request }
        }));
    }

    private async applyAgentPromptAction(action: any, context: any, files: File[], isCancelled: () => boolean, onProgress: (label: string) => void, request: string = ''): Promise<{ applied: boolean; label?: string; message?: string; downloadUrl?: string }> {
        if (context?.kind === 'workspace_page') return this.workspaceAgent.apply(action, context, isCancelled, onProgress);
        let response: any = {
            applied: false, message: '콘텐츠 워크벤치가 변경되어 수정안을 적용하지 못했습니다.'
        };
        window.dispatchEvent(new CustomEvent('ptsd:agent:prompt-apply', {
            detail: { action, context, files, isCancelled, onProgress, request, respond: (value: any) => { response = value; } }
        }));
        return await response;
    }

    public async chooseAgentSuggestion(kind: 'review' | 'schedule' | 'patient') {
        if (!this.agentConversationId || this.agentConversationChanging) return;
        this.agentHistoryPanelOpen = false;
        const suggestions = {
            review: {
                prompt: '검토할 케이스 찾아줘', permission: 'patients.read',
                response: '검토가 필요한 케이스만 보이도록 대시보드 필터를 적용했습니다.',
                action: '대시보드 · 검토 필요 필터', route: '/dashboard?case=review'
            },
            schedule: {
                prompt: '오늘 일정 확인해줘', permission: 'sessions.operate',
                response: '오늘의 치료 일정을 열었습니다.',
                action: '일정 관리 · 오늘', route: '/schedule'
            },
            patient: {
                prompt: '새 환자 등록 도와줘', permission: 'patients.write',
                response: '환자 등록 화면을 열었습니다. 가상·비식별 정보만 입력해주세요.',
                action: '환자 관리 · 환자 등록', route: '/patients?create=1'
            }
        };
        const suggestion = suggestions[kind];
        await this.appendAgentMessage('user', suggestion.prompt);
        const permissions = this.service.auth.session?.permissions;
        if (!Array.isArray(permissions) || !permissions.includes(suggestion.permission)) {
            await this.appendAgentMessage('agent', '이 작업에 필요한 접근 권한이 없습니다. 관리자에게 권한을 확인해주세요.');
            return;
        }
        await this.appendAgentMessage('agent', suggestion.response, suggestion.action);
        this.service.href(suggestion.route);
    }

    public async sendAgentMessage(event?: Event, suggestedText?: string) {
        event?.preventDefault();
        const text = String(suggestedText || this.agentDraft).trim() ||
            (this.agentAttachments.length ? '첨부한 파일의 내용을 확인해줘' : '');
        if ((!text && !this.agentAttachments.length) || this.agentSending || this.agentRepairing
            || !this.agentConversationId || this.agentConversationChanging) return;
        this.agentHistoryPanelOpen = false;
        const attachments = [...this.agentAttachments];
        const scenarioImport = this.isScenarioImportRequest(text, attachments);
        if (attachments.length && !this.agentRuntime.connected) {
            this.agentAttachmentError = '서버 Codex 계정이 연결되면 파일을 보낼 수 있습니다.';
            void this.service.render();
            return;
        }
        const shownText = attachments.length
            ? `${text}\n\n첨부 파일: ${attachments.map((file) => file.name).join(', ')}` : text;

        const userMessageSaved = this.appendAgentMessage('user', shownText);
        this.agentDraft = '';
        this.agentAttachments = [];
        this.agentAttachmentError = '';
        if (!this.agentRuntime.connected) {
            await this.appendAgentMessage('agent', '서버 공용 Codex 계정이 아직 연결되지 않았습니다. 관리자에게 연결을 요청해주세요.');
            return;
        }
        this.agentSending = true;
        const progress = this.appendAgentProgress(text);
        const active: AgentActiveRequest = {
            id: this.agentMessageId(), controller: new AbortController(), progress, stopped: false
        };
        this.agentActiveRequest = active;
        if (attachments.length && progress.progress) {
            progress.progress.context = '워크벤치 에이전트 · 파일 첨부';
            progress.progress.steps.splice(1, 0, { label: `첨부 파일 ${attachments.length}개 선택 완료`, state: 'done' });
        }
        let scenarioImportJobId = '';
        void this.service.render();
        try {
            await userMessageSaved;
            if (active.stopped) return;
            const context = scenarioImport ? null : this.agentPromptContext(text);
            const imageAgent = !scenarioImport && this.isImageAgentRequest(text, context, attachments);
            active.imageAgent = imageAgent;
            const diagnostic = !imageAgent && !scenarioImport && !attachments.length &&
                context?.kind !== 'workspace_page' && this.isAgentOperationalIssue(text) && !(context && this.isAgentPromptEditRequest(text));
            this.agentScreenInspecting = !!context && !diagnostic && !imageAgent;
            if (context && !diagnostic && !imageAgent) this.notifyAgentPromptActivity('working', text);
            if (scenarioImport && progress.progress) {
                progress.progress.context = '시나리오 세트 · 첨부 문서 분석';
                progress.progress.title = '첨부 문서의 대화를 확인하는 중';
            }
            if (diagnostic && progress.progress) {
                progress.progress.context = '워크벤치 · 서버 상태 진단';
                progress.progress.title = '권한 범위의 상태와 오류 기록을 확인하는 중';
                progress.progress.targetLinked = false;
                this.clearAgentPromptTarget();
            } else if (context && progress.progress) {
                progress.progress.context = this.isAgentReadQuestion(text)
                    ? `${this.agentCurrentPageLabel().replace('현재 화면 · ', '')} · 화면 내용 확인` : `${this.agentCurrentPageLabel().replace('현재 화면 · ', '')} · 화면 작업`;
                progress.progress.targetLinked = true;
            }
            this.advanceAgentProgress(progress,
                diagnostic ? '현재 화면 경로 확인 완료'
                    : context ? '오른쪽 워크벤치 상태 확인 완료' : '현재 화면 확인 완료',
                scenarioImport ? `첨부 파일 ${attachments.length}개에서 대화 추출·검증 중`
                    : diagnostic ? '권한 범위의 DB·작업·오류 기록 조회 · Codex 응답 대기 중'
                    : attachments.length ? `첨부 파일 ${attachments.length}개와 요청을 Codex에 전달 · 응답 대기 중`
                    : 'Codex에 요청 전달 · 응답 대기 중');
            const waitStartedAt = Date.now();
            active.waitTimer = setInterval(() => {
                if (active.stopped || progress.progress?.state !== 'running') return;
                const waiting = progress.progress.steps.some((step) =>
                    step.state === 'active' && step.label.includes('응답 대기 중'));
                if (!waiting) return;
                progress.progress.title = `Codex 응답 대기 중 · ${Math.floor((Date.now() - waitStartedAt) / 1000)}초 경과`;
                void this.service.render();
            }, 1000);
            const endpoint = imageAgent ? '/api/ptsd/codex/image-agent/start'
                : scenarioImport ? '/api/ptsd/codex/scenario-import'
                : diagnostic ? '/api/ptsd/codex/diagnose'
                : context ? '/api/ptsd/codex/prompt-action' : '/api/ptsd/codex/chat';
            const payload = new FormData();
            payload.append('message', text);
            payload.append('model', this.agentSelectedModel);
            payload.append('request_id', active.id);
            payload.append('conversation_id', this.agentConversationId);
            payload.append('csrf_token', this.service.auth.session?.csrf_token || '');
            payload.append('context', JSON.stringify(imageAgent ? this.imageAgentContext(context)
                : (context || this.agentPageContext())));
            for (const file of attachments) payload.append('attachments[]', file, file.name);
            const response = await fetch(endpoint, {
                method: 'POST', body: payload, credentials: 'same-origin', signal: active.controller.signal
            });
            const result: any = await response.json();
            if (active.waitTimer !== undefined) clearInterval(active.waitTimer);
            if (active.stopped) return;
            if (result.code !== 200) {
                this.finishAgentProgress(progress, false, '응답을 받지 못했습니다', 'Codex 응답 실패');
                await this.appendAgentMessage('agent', result.data?.message || result.responseJSON?.data?.message || '응답을 받지 못했습니다.');
            } else if (imageAgent) {
                this.registerImageAgentRun(result.data?.run);
                active.imageAgentRunId = result.data.run.id;
                this.finishAgentProgress(progress, true, '이미지 작업 등록 완료', '생성·평가 단계는 서버에서 계속 실행됩니다');
                await this.appendAgentMessage('agent', result.data.run.message
                    || '이미지 작업을 등록했습니다. 아래에서 생성·평가·보정 진행 상태와 결과를 확인할 수 있습니다.');
            } else if (scenarioImport) {
                let job = result.data;
                if (!job?.job_id || !Array.isArray(job.scenarios)) throw new Error('분석 작업을 확인할 수 없습니다.');
                scenarioImportJobId = job.job_id;
                while (!job.ready && !active.stopped) {
                    const current = job.scenarios[job.analyzed];
                    this.advanceAgentProgress(progress,
                        job.analyzed ? `${job.analyzed}/${job.count}개 시나리오 분석 완료` : '첨부 문서 대화 추출 완료',
                        `${job.analyzed + 1}/${job.count} · ${current?.title || '시나리오'} 사건·인물 정보 분석 중`);
                    const step = new FormData();
                    step.append('job_id', job.job_id);
                    step.append('request_id', active.id);
                    step.append('csrf_token', this.service.auth.session?.csrf_token || '');
                    const stepResponse = await fetch('/api/ptsd/codex/scenario-import/analyze-next', {
                        method: 'POST', body: step, credentials: 'same-origin', signal: active.controller.signal
                    });
                    const stepResult = await stepResponse.json();
                    if (stepResult.code !== 200) throw new Error(stepResult.data?.message || '시나리오 분석에 실패했습니다.');
                    job = stepResult.data;
                }
                if (active.stopped) return;
                this.finishAgentProgress(progress, true, `${job.count}개 시나리오 분석 완료`,
                    `${job.count}개 분석 완료 · 등록 전 검토 대기`);
                await this.appendAgentMessage('agent',
                    `첨부 문서에서 ${job.count}개 시나리오를 분석했습니다. 원문 대화는 유지했고 사건·인물 정보와 콘텐츠 요소를 정리했습니다. 시나리오 세트에서 내용을 확인한 뒤 ‘검토한 내용 등록’을 눌러주세요. 아직 등록되지 않았습니다.`);
                this.presentScenarioImportJob(job.job_id, job);
            } else if (diagnostic) {
                const report = result.data?.report;
                if (!report || !Array.isArray(report.evidence)) throw new Error('진단 결과를 확인하지 못했습니다.');
                this.advanceAgentProgress(progress, '서버 상태와 작업 기록 확인 완료', '근거와 복구 가능 여부 정리 중');
                this.finishAgentProgress(progress, true, '진단 완료', '근거와 복구 가능 여부 확인 완료');
                await this.appendAgentMessage('agent', this.agentDiagnosticText(report), undefined,
                    report.repair?.type === 'retry_generation_job' ? report.repair : undefined);
            } else if (context?.kind === 'workspace_page') {
                const completed: string[] = [];
                let screen = context;
                let action = result.data?.action;
                for (let round = 0; round < 8; round++) {
                    if (active.stopped) return;
                    if (action?.kind === 'reply_only') {
                        this.finishAgentProgress(progress, true, completed.length ? '화면 작업 완료' : '답변 완료',
                            completed.length ? completed.join(' · ') : '현재 화면과 조회 자료 확인 완료');
                        await this.appendAgentMessage('agent', (completed.length ? `실행한 작업: ${completed.join(' · ')}\n\n` : '')
                            + (action.message || '현재 화면을 확인했습니다.'));
                        break;
                    }
                    const applied = await this.workspaceAgent.apply(action, screen, () => active.stopped,
                        label => this.advanceAgentProgress(progress, '현재 화면 작업 확인 완료', label));
                    if (active.stopped) return;
                    if (!applied.applied && !applied.retry) {
                        this.finishAgentProgress(progress, false, '화면 작업 중단', applied.message);
                        await this.appendAgentMessage('agent', (completed.length ? `실행한 작업: ${completed.join(' · ')}\n` : '') + applied.message);
                        break;
                    }
                    if (applied.applied) completed.push(applied.label);
                    const followUp = applied.retry || action.continue || applied.continue;
                    if (!followUp || round === 7) {
                        this.finishAgentProgress(progress, !followUp, followUp ? '후속 작업 확인 필요' : '화면 작업 완료', completed.join(' · '));
                        await this.appendAgentMessage('agent', `실행한 작업: ${completed.join(' · ')}. `
                            + (followUp ? '작업 단계가 많아 여기까지 실행했습니다. 현재 화면에서 이어서 요청해주세요.' : applied.message));
                        break;
                    }
                    screen = this.workspaceAgent.capture();
                    if (!screen) throw new Error('현재 메뉴에서 지원하는 화면을 확인하지 못했습니다.');
                    screen.completed_steps = [...completed];
                    this.advanceAgentProgress(progress, applied.retry ? '배경 갱신 후 화면 재확인 완료' : applied.label + ' 완료', '변경된 화면에서 다음 작업 확인 중');
                    const nextPayload = new FormData();
                    nextPayload.set('message', text);
                    nextPayload.set('context', JSON.stringify(screen));
                    nextPayload.set('model', this.agentSelectedModel);
                    nextPayload.set('request_id', active.id);
                    nextPayload.set('conversation_id', this.agentConversationId);
                    nextPayload.set('csrf_token', this.service.auth.session?.csrf_token || '');
                    const next = await (await fetch('/api/ptsd/codex/prompt-action', {
                        method: 'POST', body: nextPayload, credentials: 'same-origin', signal: active.controller.signal
                    })).json();
                    if (next.code !== 200) throw new Error(next.data?.message || '다음 화면 작업을 확인하지 못했습니다.');
                    action = next.data?.action;
                }
            } else if (context && ['edit_prompts', 'run_actions'].includes(result.data?.action?.kind)) {
                this.advanceAgentProgress(progress, 'Codex 작업안 수신 완료', '워크벤치 작업 확인 중');
                const applied = await this.applyAgentPromptAction(
                    result.data.action, context, attachments, () => active.stopped,
                    (label: string) => {
                        if (!progress.progress || active.stopped) return;
                        const previous = progress.progress.steps.find((step) => step.state === 'active')?.label || '';
                        this.advanceAgentProgress(progress,
                            previous === '워크벤치 작업 확인 중' ? '화면 작업 요청 확인 완료'
                                : previous.replace(/\s*중$/, '') + ' 완료', label);
                    }, text
                );
                if (active.stopped) return;
                if (applied.applied) {
                    if (progress.progress) {
                        progress.progress.context = `${this.agentCurrentPageLabel()} · 화면 작업`;
                    }
                    this.finishAgentProgress(progress, true,
                        `${applied.label || '화면 작업'} 완료`, `${applied.label || '화면 작업'} 완료`);
                    await this.appendAgentMessage('agent', applied.message || `${applied.label} 완료했습니다.`,
                        applied.downloadUrl ? `download:${applied.downloadUrl}` : undefined);
                } else {
                    this.finishAgentProgress(progress, false,
                        applied.label ? `${applied.label} 이후 작업 중단` : '화면 작업을 완료하지 못했습니다',
                        applied.message || '화면 작업 실패');
                    const partial = applied.label ? `${applied.label}까지 완료했습니다. ` : '';
                    await this.appendAgentMessage('agent', partial + (applied.message || '현재 화면이 바뀌어 수정안을 적용하지 못했습니다. 다시 요청해주세요.'));
                }
            } else if (!context || result.data?.action?.kind === 'reply_only') {
                if (context) this.notifyAgentPromptActivity('inspected');
                this.finishAgentProgress(progress, true, '답변 완료', 'Codex 응답 수신 완료');
                await this.appendAgentMessage('agent', context
                    ? (result.data?.action?.message || '수정할 내용을 조금 더 구체적으로 알려주세요.')
                    : (result.data?.answer || '응답을 받지 못했습니다.'));
            } else {
                this.finishAgentProgress(progress, false, '작업안을 확인하지 못했습니다', 'Codex 작업안 형식 확인 실패');
                await this.appendAgentMessage('agent', '수정안 형식을 확인하지 못했습니다. 다시 요청해주세요.');
            }
        } catch (error: any) {
            if (active.stopped) return;
            this.finishAgentProgress(progress, false, '작업을 완료하지 못했습니다');
            if (active.imageAgent) void this.refreshAgentImageRuns();
            await this.appendAgentMessage('agent', active.imageAgent
                ? '이미지 작업의 등록 응답을 확인하지 못했습니다. 같은 대화의 작업 상태를 다시 불러오고 있습니다. 확인 전에는 같은 요청을 다시 보내지 마세요.'
                : scenarioImportJobId
                ? `${error?.message || '분석이 중단되었습니다.'} 저장된 분석 작업을 시나리오 세트에서 다시 진행할 수 있습니다.`
                : (error?.message || '서버와 연결하지 못했습니다. 잠시 후 다시 시도해주세요.'));
            if (scenarioImportJobId) {
                this.presentScenarioImportJob(scenarioImportJobId);
            }
        } finally {
            if (active.waitTimer !== undefined) clearInterval(active.waitTimer);
            if (this.agentActiveRequest === active) {
                this.notifyAgentPromptActivity('clear');
                this.agentScreenInspecting = false;
                this.agentActiveRequest = null;
                this.agentSending = false;
                void this.service.render();
            }
        }
    }

    public async stopAgentResponse() {
        const active = this.agentActiveRequest;
        if (!active || active.stopped || active.progress.progress?.state !== 'running') return;
        active.stopped = true;
        active.controller.abort();
        if (active.waitTimer !== undefined) clearInterval(active.waitTimer);
        this.agentActiveRequest = null;
        this.agentSending = false;
        this.agentScreenInspecting = false;
        this.notifyAgentPromptActivity('clear');
        this.clearAgentPromptTarget();
        if (active.progress.progress) {
            active.progress.progress.state = 'cancelled';
            active.progress.progress.title = '작업 중지를 요청했습니다';
            active.progress.progress.targetLinked = false;
            const runningStep = active.progress.progress.steps.find((step) => step.state === 'active');
            if (runningStep) {
                runningStep.label = runningStep.label.replace(/\s*중$/, '') + ' 중지됨';
                runningStep.state = 'unavailable';
            }
            active.progress.progress.steps.push({ label: '서버의 Codex 작업 종료 확인 중', state: 'active' });
        }
        void this.service.render();
        try {
            const payload = new FormData();
            payload.append('request_id', active.id);
            payload.append('csrf_token', this.service.auth.session?.csrf_token || '');
            if (active.imageAgent) {
                payload.append('conversation_id', this.agentConversationId);
                if (active.imageAgentRunId) payload.append('run_id', active.imageAgentRunId);
            }
            const response = await fetch(active.imageAgent ? '/api/ptsd/codex/image-agent/cancel' : '/api/ptsd/codex/cancel', {
                method: 'POST', body: payload, credentials: 'same-origin'
            });
            const result = await response.json();
            if (result.code !== 200) throw new Error('서버 작업 중지 실패');
            if (active.progress.progress) {
                active.progress.progress.title = '작업을 중지했습니다';
                const runningStep = active.progress.progress.steps.find((step) => step.state === 'active');
                if (runningStep) {
                    runningStep.label = '서버에 중지 신호 전달 완료';
                    runningStep.state = 'done';
                }
            }
            if (active.imageAgent) await this.refreshAgentImageRuns();
            await this.appendAgentMessage('agent', '요청을 중지했습니다.');
        } catch (_error) {
            if (active.progress.progress) {
                active.progress.progress.state = 'failed';
                active.progress.progress.title = '화면 응답 중지 · 서버 종료 미확인';
                const runningStep = active.progress.progress.steps.find((step) => step.state === 'active');
                if (runningStep) {
                    runningStep.label = '서버 작업 중지를 확인하지 못함';
                    runningStep.state = 'failed';
                }
            }
            await this.appendAgentMessage('agent', '화면의 응답 대기는 중지했지만 서버 작업 종료를 확인하지 못했습니다.');
        }
        void this.service.render();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public async openMobileNavigation(event?: Event) {
        const trigger = event?.currentTarget;
        this.mobileNavigationReturnFocus = trigger instanceof HTMLElement
            ? trigger
            : (document.activeElement instanceof HTMLElement ? document.activeElement : null);
        await this.service.status.toggle('navbar', false);
        setTimeout(() => {
            const drawer = document.getElementById('workbench-mobile-drawer');
            const closeButton = drawer?.querySelector<HTMLElement>('[data-drawer-close="true"]');
            (closeButton || drawer)?.focus();
        }, 0);
    }

    public async closeMobileNavigation() {
        await this.service.status.toggle('navbar', true);
        const target = this.mobileNavigationReturnFocus;
        this.mobileNavigationReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onMobileNavigationKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeMobileNavigation();
            return;
        }
        if (event.key !== 'Tab') return;

        const drawer = document.getElementById('workbench-mobile-drawer');
        if (!drawer) return;
        const focusable = Array.from(drawer.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            drawer.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }
}

// Only controls rendered by the current application are addressable. No selectors,
// URLs, scripts or API payloads from the model are executed.
export class WorkspaceScreenAgent {
    static readonly pages: Record<string, string> = {
        '/content': '콘텐츠 워크벤치', '/references': '레퍼런스 자료실', '/scenario-sets': '시나리오 세트',
        '/prompts': '프롬프트 관리', '/schedule': '일정 관리', '/members': '멤버 관리', '/ai/usage': 'AI 비용',
        '/dashboard': '대시보드', '/patients': '환자 관리', '/sessions': '치료 세션',
        '/review': '콘텐츠 검토', '/audit': '감사 기록', '/settings': '운영 설정',
        '/mypage': '내 프로필', '/posts': '게시판', '/content/comparisons': '콘텐츠 비교'
    };
    static pageLabel(path: string): string {
        return this.pages[path] || (/^\/patients\/[^/]+$/.test(path) ? '환자 상세'
            : /^\/posts\/[^/]+(?:\/[^/]+)?$/.test(path) ? '게시글' : '');
    }
    private ids = new WeakMap<Element, string>();
    private sequence = 0;
    private snapshot: any = null;
    private userRevision = 0;
    private watchingUserChanges = false;

    private clean(value: any, limit: number = 180) {
        return String(value || '').replace(/임시\s*비밀번호\s*:\s*\S+/gi, '임시 비밀번호: [비공개]')
            .replace(/\s+/g, ' ').trim().slice(0, limit);
    }

    private visible(element: Element): boolean {
        return !!element.getClientRects().length && !element.closest(
            '[hidden], [inert], [data-agent-ignore], .workbench-agent-panel, .workbench-agent-runtime-backdrop');
    }

    private id(element: Element): string {
        let id = this.ids.get(element);
        if (!id) { id = `ui${++this.sequence}`; this.ids.set(element, id); }
        return id;
    }

    private activeDialog(): HTMLElement | null {
        return Array.from(document.querySelectorAll<HTMLElement>(
            '[role="dialog"], .swal2-container, wiz-portal-season-modal'))
            .filter(element => this.visible(element) && this.clean(element.innerText)
                && !element.closest('.workbench-agent-panel, .workbench-agent-runtime-backdrop')).at(-1) || null;
    }

    private fingerprint(value: string): string {
        let hash = 2166136261;
        for (let index = 0; index < value.length; index++) hash = Math.imul(hash ^ value.charCodeAt(index), 16777619);
        return (hash >>> 0).toString(16);
    }

    capture(): any | null {
        const path = window.location.pathname;
        if (!WorkspaceScreenAgent.pageLabel(path) || typeof document.querySelector !== 'function') return null;
        const root = document.querySelector<HTMLElement>('.workbench-main');
        if (!root) return null;
        if (!this.watchingUserChanges) {
            this.watchingUserChanges = true;
            const trackUserChange = (event: Event) => {
                const target = event.target as Element;
                if (event.isTrusted && target?.closest && !target.closest('.workbench-agent-panel')
                    && target.closest('.workbench-main, .wb-nav-item, .workbench-mobile-menu')) this.userRevision++;
            };
            for (const type of ['input', 'change', 'click']) document.addEventListener(type, trackUserChange, true);
        }
        const roots: HTMLElement[] = [root];
        const dialog = this.activeDialog();
        if (dialog && !root.contains(dialog)) roots.push(dialog);
        const readOnly = path === '/ai/usage';
        const controls: any[] = [];
        const bindings = new Map<string, HTMLElement>();
        const elements = (dialog ? [dialog] : roots).flatMap(parent => Array.from(parent.querySelectorAll<HTMLElement>(
            'input,textarea,select,button,[role="button"],[role="combobox"],[role="option"],[role="tab"],a[href],tr[tabindex]')));
        // Menu links are existing permission-filtered application links only.
        if (!dialog) {
            document.querySelectorAll<HTMLElement>('.wb-nav-item[href], .workbench-mobile-menu, .wb-profile-action[href]')
                .forEach(element => elements.unshift(element));
        }
        elements.sort((a, b) => Number(!a.matches('input,textarea,select')) - Number(!b.matches('input,textarea,select')));
        const seen = new Set<HTMLElement>();
        let budget = 0;
        for (const element of elements) {
            if (seen.has(element) || !this.visible(element)) continue;
            seen.add(element);
            const tag = element.tagName.toLowerCase();
            if (readOnly && tag !== 'a') continue;
            const type = String(element.getAttribute('type') || 'text').toLowerCase();
            if (['password', 'hidden', 'file'].includes(type) || element.hasAttribute('readonly')) continue;
            if (tag === 'a') {
                const url = new URL(element.getAttribute('href') || '', window.location.href);
                if (url.origin !== window.location.origin || !WorkspaceScreenAgent.pageLabel(url.pathname)) continue;
            }
            const field = element as HTMLInputElement;
            const label = this.clean(element.getAttribute('aria-label')
                || (element.getAttribute('aria-labelledby') || '').split(/\s+/)
                    .filter(Boolean).map(id => document.getElementById(id)?.textContent || '').join(' ')
                || (field.labels ? Array.from(field.labels).map(item => {
                    const copy = item.cloneNode(true) as HTMLElement;
                    copy.querySelectorAll('input,textarea,select,button').forEach(child => child.remove());
                    return copy.textContent;
                }).join(' ') : '')
                || element.getAttribute('placeholder') || element.innerText || element.getAttribute('title'));
            if (!label) continue;
            const kind = tag === 'select' ? 'select' : tag === 'textarea' || tag === 'input'
                ? (['checkbox', 'radio'].includes(type) ? 'checkbox' : 'field') : 'button';
            const value = kind === 'checkbox' ? String(field.checked) : kind === 'button' ? '' : String(field.value || '');
            // Large existing prompts remain visible as context, but cannot be replaced from truncated data.
            if (value.length > 8000) continue;
            const control: any = { id: this.id(element), kind, label, value, role: element.getAttribute('role') || '',
                disabled: element.matches(':disabled') || element.getAttribute('aria-disabled') === 'true',
                selected: element.getAttribute('aria-selected') || element.getAttribute('aria-pressed')
                    || String(element.classList.contains('is-active') || element.classList.contains('is-selected')),
                expanded: element.getAttribute('aria-expanded') || '',
                context: this.clean(element.closest('tr,fieldset,[role="group"],[role="listbox"],.reference-card,.schedule-appointment,.wb-analysis-cut,.wb-new-control-block,.rounded-xl')?.textContent, 180) };
            if (element.hasAttribute('data-agent-select-scenario')) {
                control.select_scenario = element.getAttribute('data-agent-select-scenario');
            }
            if (tag === 'a') {
                control.navigation = true;
                control.target_path = new URL(element.getAttribute('href') || '', window.location.href).pathname;
            }
            if (kind === 'select') control.options = Array.from((element as HTMLSelectElement).options)
                .slice(0, 80).map(option => ({ value: option.value, label: this.clean(option.text, 90), disabled: option.disabled }));
            if (kind === 'field') {
                control.input_type = type;
                control.max_length = field.maxLength > 0 ? Math.min(field.maxLength, 8000) : 8000;
                control.min = field.min || ''; control.max = field.max || '';
            }
            const size = JSON.stringify(control).length;
            if (controls.length >= 140 || budget + size > 31000) continue;
            budget += size;
            controls.push(control); bindings.set(control.id, element);
        }
        const state = JSON.stringify({ route: window.location.pathname + window.location.search, controls,
            dialog: this.clean(dialog?.innerText, 1800) });
        const filters: any = {};
        root.querySelectorAll<HTMLSelectElement>('[data-agent-usage-filter]').forEach(element => {
            const key = element.dataset.agentUsageFilter;
            if (key) filters[key] = key === 'days' ? Number(element.value.split(':').pop()?.trim()) : element.value;
        });
        const context = {
            kind: 'workspace_page', path, page_label: WorkspaceScreenAgent.pageLabel(path), read_only: readOnly,
            snapshot_id: Array.from(window.crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join(''),
            fingerprint: this.fingerprint(state),
            screen_text: roots.map(element => this.clean(element.innerText, 5500)).join('\n').slice(0, 7500),
            active_dialog: this.clean(dialog?.innerText, 1800),
            controls, filters,
            alerts: Array.from(root.querySelectorAll<HTMLElement>('[role="alert"]'))
                .filter(element => this.visible(element)).map(element => this.clean(element.innerText, 300)).slice(0, 5)
        };
        this.snapshot = { context, bindings, userRevision: this.userRevision };
        return context;
    }

    private async observeAction(action: () => void, cancelled: () => boolean, navigationPath: string = '', scenarioSelection: string = '', tabTarget: HTMLElement | null = null) {
        const results: any[] = [];
        let pending = 0;
        let lastActivity = Date.now();
        const relevant = (url: string) => /\/(?:wiz\/api\/page\.|api\/ptsd\/(?!codex))/.test(url);
        const record = (url: string, status: number, body: any) => {
            if (!relevant(url)) return;
            results.push({ code: Number(body?.code || status), message: this.clean(body?.data?.message || body?.message, 300) });
            lastActivity = Date.now();
        };
        const originalSend = XMLHttpRequest.prototype.send;
        const wrappedSend = function(this: XMLHttpRequest, ...args: any[]) {
            pending++; lastActivity = Date.now();
            this.addEventListener('loadend', () => {
                pending--; lastActivity = Date.now();
                let body: any;
                try { body = this.responseType === 'json' ? this.response : JSON.parse(this.responseText); } catch (_) { /* Not a JSON API. */ }
                record(this.responseURL, this.status || 503, body);
            }, { once: true });
            try { return originalSend.apply(this, args); } catch (error) { pending--; throw error; }
        };
        const originalFetch = window.fetch;
        const wrappedFetch: typeof fetch = async (...args) => {
            const url = String((args[0] as Request)?.url || args[0]);
            if (!relevant(url)) return originalFetch.apply(window, args);
            pending++; lastActivity = Date.now();
            try {
                const response = await originalFetch.apply(window, args);
                if (response.headers.get('content-type')?.includes('application/json')) {
                    record(url, response.status, await response.clone().json().catch(() => null));
                } else record(url, response.status, null);
                return response;
            } catch (error) { record(url, 503, null); throw error; }
            finally { pending--; lastActivity = Date.now(); }
        };
        XMLHttpRequest.prototype.send = wrappedSend;
        window.fetch = wrappedFetch;
        const started = Date.now();
        const tabReady = () => !!tabTarget?.isConnected && this.visible(tabTarget)
            && tabTarget.getAttribute('aria-selected') === 'true';
        const scenarioReady = () => !!scenarioSelection && window.location.pathname === '/content'
            && new URLSearchParams(window.location.search).get('scenario') === scenarioSelection
            && !!document.querySelector<HTMLElement>('#wb-media-tab-image')?.getClientRects().length;
        try {
            action();
            const observationLimit = navigationPath || scenarioSelection || tabTarget ? 60000 : 20000;
            while (!cancelled() && Date.now() - started < observationLimit) {
                await new Promise(resolve => window.setTimeout(resolve, 100));
                if (navigationPath && window.location.pathname === navigationPath
                    && document.querySelector('.workbench-main h1') && Date.now() - started >= 650) break;
                if ((scenarioReady() || tabReady()) && Date.now() - started >= 650) break;
                if (!pending && Date.now() - lastActivity >= 650) break;
            }
            return { results, waiting: pending > 0,
                navigated: scenarioReady() || tabReady() || !!navigationPath && window.location.pathname === navigationPath
                    && !!document.querySelector('.workbench-main h1') };
        } finally {
            if (XMLHttpRequest.prototype.send === wrappedSend) XMLHttpRequest.prototype.send = originalSend;
            if (window.fetch === wrappedFetch) window.fetch = originalFetch;
        }
    }

    async apply(action: any, original: any, cancelled: () => boolean, progress: (label: string) => void): Promise<any> {
        const snapshot = this.snapshot;
        if (!snapshot || snapshot.context.snapshot_id !== original?.snapshot_id) {
            return { applied: false, message: '현재 화면의 작업 연결을 다시 확인해주세요.' };
        }
        const current = this.capture();
        if (!current || current.path !== original.path || snapshot.userRevision !== this.userRevision) {
            return { applied: false, message: '화면이나 입력값이 바뀌었습니다. 현재 화면에서 다시 요청해주세요.' };
        }
        if (current.fingerprint !== original.fingerprint) {
            // Background results may add unrelated buttons while the model is responding.
            // Keep the original element identity, dialog scope and every existing input value.
            let stableTargets = false;
            try {
                stableTargets = Array.isArray(action?.operations) && action.operations.length > 0
                    && action.operations.every((operation: any) => {
                        const id = JSON.parse(operation.value).id;
                        const before = original.controls.find((item: any) => item.id === id);
                        const after = current.controls.find((item: any) => item.id === id);
                        return before && after && JSON.stringify(before) === JSON.stringify(after)
                            && snapshot.bindings.get(id) === this.snapshot.bindings.get(id);
                    });
            } catch (_) { /* Invalid operations are rejected without execution. */ }
            const unchangedExistingControls = original.controls.every((before: any) =>
                current.controls.some((after: any) => after.id === before.id
                    && JSON.stringify(after) === JSON.stringify(before)));
            const viewOnly = stableTargets && action.operations.every((operation: any) => {
                const before = original.controls.find((item: any) => item.id === JSON.parse(operation.value).id);
                return operation.type === 'click_control' && (before?.navigation || before?.role === 'tab');
            });
            const backgroundViewUpdate = viewOnly && snapshot.userRevision === this.userRevision;
            if (!stableTargets || !(unchangedExistingControls || backgroundViewUpdate)
                || current.active_dialog !== original.active_dialog) {
                return { applied: false, retry: true, message: '배경 조회로 화면이 갱신되어 새 작업안을 확인합니다.' };
            }
        }
        const operations = action?.operations;
        if (action?.kind !== 'run_actions' || !Array.isArray(operations) || !operations.length
            || operations.length > 8 || (action.edits || []).length) return { applied: false, message: '허용되지 않은 화면 작업입니다.' };
        const planned: any[] = [];
        const seen = new Set<string>();
        for (const operation of operations) {
            let payload: any;
            try { payload = JSON.parse(operation.value); } catch (_) { return { applied: false, message: '화면 작업 내용을 확인하지 못했습니다.' }; }
            const control = original.controls.find((item: any) => item.id === payload.id);
            const target = snapshot.bindings.get(payload.id);
            if (!control || !target || ((original.read_only || snapshot.context.read_only) && !control.navigation) || control.disabled || seen.has(payload.id) || operation.attachment_index !== -1
                || typeof payload.value !== 'string' || !['set_field', 'click_control'].includes(operation.type)
                || (operation.type === 'click_control' ? control.kind !== 'button' || payload.value !== '' || operation !== operations.at(-1)
                    : control.kind === 'button' || payload.value.length > (control.max_length || 8000)
                        || (control.kind === 'select' && !control.options.some((item: any) => !item.disabled && item.value === payload.value))
                        || (control.kind === 'checkbox' && !['true', 'false'].includes(payload.value)))) {
                return { applied: false, message: '현재 화면에서 허용되지 않는 입력이나 버튼입니다.' };
            }
            if (operation.type === 'set_field' && control.kind === 'field' && target.tagName === 'INPUT') {
                const probe = target.cloneNode(false) as HTMLInputElement;
                probe.value = payload.value;
                const validity = probe.validity;
                if (probe.value !== payload.value || validity.badInput || validity.rangeOverflow
                    || validity.rangeUnderflow || validity.stepMismatch) {
                    return { applied: false, message: '입력값의 형식과 허용 범위를 확인해주세요.' };
                }
            }
            seen.add(payload.id); planned.push({ operation, payload, control, target });
        }
        const labels: string[] = [];
        for (const item of planned) {
            if (cancelled()) return { applied: false, label: labels.join(' · '), message: '요청을 중지했습니다.' };
            const { operation, payload, control, target } = item;
            if (!target.isConnected || !this.visible(target) || target.matches(':disabled')) {
                return { applied: false, label: labels.join(' · '), message: '작업 중 화면이 바뀌었습니다. 현재 화면에서 다시 요청해주세요.' };
            }
            if (operation.type === 'click_control' && target.getAttribute('type') === 'submit'
                && (target as HTMLButtonElement).form && !(target as HTMLButtonElement).form!.checkValidity()) {
                return { applied: false, label: labels.join(' · '), message: '필수 입력값과 입력 형식을 확인해주세요.' };
            }
            const alertMessages = () => Array.from(document.querySelectorAll<HTMLElement>(
                '.workbench-main [role="alert"], [role="dialog"] [role="alert"], .swal2-validation-message'))
                .filter(element => this.visible(element)).map(element => this.clean(element.textContent, 300)).filter(Boolean);
            const existingAlerts = new Set(alertMessages());
            progress(`‘${control.label}’ ${operation.type === 'set_field' ? '입력' : '실행'} 중`);
            const observed = await this.observeAction(() => {
                target.classList.add('workbench-agent-action-target');
                window.setTimeout(() => target.classList.remove('workbench-agent-action-target'), 4500);
                if (operation.type === 'click_control') target.click();
                else {
                    if (control.kind === 'checkbox') (target as HTMLInputElement).checked = payload.value === 'true';
                    else (target as HTMLInputElement).value = payload.value;
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                    target.dispatchEvent(new Event('change', { bubbles: true }));
                    target.dispatchEvent(new Event('blur'));
                }
            }, cancelled, control.navigation ? control.target_path : '', control.select_scenario || '', control.role === 'tab' ? target : null);
            const failure = observed.results.find((result: any) => result.code < 200 || result.code >= 400);
            if (failure) return { applied: false, label: labels.join(' · '), message: failure.message || '서버에서 화면 작업을 처리하지 못했습니다.' };
            if (control.navigation && window.location.pathname !== control.target_path) {
                return { applied: false, label: labels.join(' · '), message: '메뉴 이동이 완료되지 않았습니다. 현재 화면의 확인 요청을 먼저 처리해주세요.' };
            }
            if (control.role === 'tab' && target.getAttribute('aria-selected') !== 'true') {
                return { applied: false, label: labels.join(' · '), message: '요청한 탭이 선택되지 않았습니다. 현재 화면을 확인해주세요.' };
            }
            if (observed.waiting && !observed.navigated) return { applied: false, label: labels.join(' · '), message: '요청을 전달했지만 서버 처리가 진행 중입니다. 결과를 확인한 뒤 다시 요청해주세요.' };
            const validation = alertMessages().find(message => !existingAlerts.has(message));
            if (validation) return { applied: false, label: labels.join(' · '), message: validation };
            if (operation.type === 'set_field') {
                const actual = control.kind === 'checkbox' ? String((target as HTMLInputElement).checked)
                    : String((target as HTMLInputElement).value);
                if (actual !== payload.value) return { applied: false, label: labels.join(' · '), message: '입력값이 화면에 반영되지 않았습니다. 현재 값을 확인해주세요.' };
            }
            labels.push(`‘${control.label}’ ${operation.type === 'set_field' ? '입력' : '실행'}`);
        }
        const dialog = this.activeDialog();
        return { applied: true, label: labels.join(' · '), message: '현재 화면에 적용했습니다.',
            continue: !!dialog && this.clean(dialog.innerText, 1800) !== original.active_dialog };
    }
}

export default LayoutSidebarComponent;